import React, { Component } from "react";
import classes from "./Vender.module.css";
import axios from "../../../../axios-order";
import ErrorIcon from "@material-ui/icons/Error";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Card from "../../../../components/ui/Cards";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";
import DataTables from "material-ui-datatables";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import VenderMaster from "../../../../asserts/templates/vendor_management.xlsx";
import TextField from "@material-ui/core/TextField";
import BasicModal from "../../../../components/ui/basicModal";
import { ValidatorForm } from "react-material-ui-form-validator";
import InputField from "../../../../components/ui/inputField";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Drawer from "@material-ui/core/Drawer";
import ClearIcon from "@material-ui/icons/Clear";
import CircularProgress from "@material-ui/core/CircularProgress";
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import SelectField from "../../../../components/ui/select";
import { toast } from "react-toastify";

import CustomTable from "../../../../components/ui/Table/Table";
import { TablePagination } from "@material-ui/core";
import RefreshIcon from "@mui/icons-material/Refresh";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RightDrawer from "../../../../components/ui/RightDrawer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { withRouter } from 'react-router-dom';
import ZohoModel from "../../../../components/ZohoModel/ZohoModel";
import ErpConnectorModel from "../../../../components/ZohoModel/ErpConnector";
import { canWrite } from "../../../../utils/privilegeUtils";
import TuneIcon from "@mui/icons-material/Tune";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Chip from "@material-ui/core/Chip";

let flagForVendorMang = 1;
let variableForTimerForZoho = null;

// Set to true AFTER BoxWrapper has been given a `headerExtra` prop (render
// {props.headerExtra} right after its search input). The Filter button then
// appears next to the Vendor Details search. While false, the button is
// rendered just above the table instead, so it never disappears.
const FILTER_BUTTON_IN_BOXWRAPPER = true;


const indianFormat = (date) => {
  let dateArr = date.split("-");
  return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
};
class VendorManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      effitracCol: [
        {
          key: "Venodr Name",
          render: (index, row) => {
            return row["venodrName"];
          },
        },
        {
          key: "Vendor Code+",
          render: (index, row) => {
            return row["erpVendorCode"];
          },
        },
        {
          key: "gstin",
          render: (index, row) => {
            return row["vendorGstin"];
          },
        },
        {
          key: "pan",
          render: (index, row) => {
            return row["vendorPan"];
          },
        },

        {
          key: "tan",
          render: (index, row) => {
            return row["vendorTan"];
          },
        },
        {
          key: "tdsPercentage",
          render: (index, row) => {
            return row["tdsPercentage"];
          },
        },
      ],
      effitracData: null,
      oldEffitracData: null,
      isCustVendorRequired: true,
      effitracHeader: [
        { label: "Vendor Name" },
        { label: "Vendor Code+" },
        { label: "GSTIN" },
        { label: "PAN" },

        { label: "TAN" },
        { label: "TDS %" },
      ],
      read_only: "",
      actionHeaderForZoho: [
        { id: "country", name: "Country" },
        { id: "state", name: "State" },
        { id: "contactName", name: "Contact Name" },
        { id: "contactNumber", name: "Contact Number" },
        { id: "vendorEmail", name: "Email" },
        { id: "address", name: "Address" },
        { id: "vendorPan", name: "PAN" },
        { id: "vendorTan", name: "Tan" },
        { id: "tcsPercentage", name: "TCS %" },
        { id: "gstRegistrationType", name: "GST Registration Type" },
        { id: "purchaseManagerName", name: "Purchase Manager Name" },
        {
          id: "purchaseManagerContactNumber",
          name: "Purchase Manager Contact Number",
        },
        { id: "purchaseManagerEmail", name: "Purchase Manager Email" },
        { id: "creditDays", name: "Credit Days" },
        { id: "thresholdLimitFlag", name: "TDS Threshold Limit Applicability" },
        { id: "residentFlag", name: "Resident" },
        { id: "section206ABFlag", name: "Section 206AB" },
        { id: "comments", name: "Comments" },
      ],
      next: {},
      prev: {},
      file_value: null,
      total_records: 0,
      errorPage: 1, // Current page
      perErrorPages: 10, // Records per page
      errortotal: 0, // Total records 
      successful_records: 0,
      error_records: 0,
      error_rows: {},
      loadingExport: false,
      sellerCustomerCol: [
        {
          label: "GSTIN",
          render: (name, all) => {
            return all["record"]["vendorGstin"];
          },
        },
        { key: "row", label: "Row #" },
        {
          label: "Errors",
          render: (name, all) => {
            return Object.keys(all["errors_in"]).map((i, v) => {
              return (
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <span>{i}</span>&nbsp;<span>:</span>&nbsp;
                  <span style={{ color: "red" }}>
                    {all["errors_in"][i].join(",")}
                  </span>
                </div>
              );
            });
          },
        },
        // {label:"Status",key:"status"}
      ],
      sellerCustomerData: [],
      error: null,

      allArcCustomerDataPurchase: [],
      OriginalDataAllArcCustomerDataPurchase: [],
      showDrawer: false,
      showData: [],
      showUploadData: false,
      loading: false,

      add_DrawerOpen: false,
      addCustomerData: {
        erpVendorCode: "",
        address: "",
        contactName: "",
        contactNumber: "",
        vendorEmail: "",
        vendorTan: "",
        purchaseManagerName: "",
        isOpenUpdateTanModal: false,
        isLoaderforupdateTanButton: false,
        purchaseManagerContactNumber: "",
        purchaseManagerEmail: "",
        gstRegistrationType: "",
        tcsPercentage: null,
        tdsPercentage: null,
        thresholdLimitFlag: "",
        residentFlag: "",
        comments: "",
        vendorGstin: "",
        creditDays: null,
        vendorPan: "",
        section206ABFlag: "",
        isExporting: false,
        isExportingAll: false,
      },

      //..............Edited by Harsh............
      openZohoDrawer: false,
      messageForConnection: "Establish Connection",
      buttonColor: "red",
      grantToken: "",
      url: "",
      zohoDate: {},

      edit_DrawerOpen: false,
      editCustomerData: {},

      autoSync: false,

      openImportEffitracDrawer: false,
      importEffitracFetchData: {},
      effitracFetchedRecords: {},
      updateTanGetApiData: {},
      fetrac: "",
      actions: [
        {
          label: "Show",
          onclickEvent: (index, row) => this.openModal(index),
        },
      ],
      effitracInvShow: false,
      targetId: null,
      tcsPercentage: 0,
      tdsPercentageKey: true,
      tcsPercentageKey: false,

      // pagination state
      page: 0,
      rowsPerPage: 25,
      rowCount: 0,
      searchInput: "",

      // upload history table data
      uploadHistoryTableData: [],
      // showUploadHistroyTable: false,

      flagForZoho: false,
      timerForZoho: 60,
      loaderForVendorMgmt: true,
      // variableForTimerForZoho:null ,
      erpConnectorModelOpen: false,
      erpConnectorName: '',
      erpDataExportLoading: false,
      importToCwsLoading: false,

      // ---------------------------------------------------------------
      // IN-GRID MULTI-FIELD FILTER (same pattern as Collections / Payment
      // Advice / Business Customer Management): a dedicated filter row sits
      // directly under the sticky grouped header, one compact box per
      // column. Each box takes a comma-separated "is any of" list, and
      // every typed box is combined (AND/OR) into a SINGLE apply.
      // ---------------------------------------------------------------
      // inlineFilterValues: what's currently typed into each column's box,
      // keyed by field — draft state, not yet sent to the backend.
      inlineFilterValues: {},
      // appliedFilters: the conditions actually in effect on the table.
      //   Each condition: { field, value } — value is the raw comma string.
      appliedFilters: [],
      // filterMatchType: "AND" (every filled column must match) or "OR"
      // (any filled column matching is enough).
      filterMatchType: "AND",
      // Mirrors appliedFilters into the shape sent to the backend; kept in
      // state so pagination handlers can tell "filtered" from "unfiltered".
      activeFilters: null,

      // ---------------------------------------------------------------
      // COMMON FILTER PANEL — one "Filter" button opens a compact side
      // panel next to the table (Basic filters open, Advanced collapsed).
      // "Apply Filters" commits everything in a SINGLE api call through the
      // same appliedFilters / applyDynamicFilters flow used above.
      // ---------------------------------------------------------------
      filterPanelOpen: false,
      advancedFiltersOpen: false,
      // draftValues: what is typed in the panel, keyed by column key.
      draftValues: {},
    };
  }

  // ---------------------------------------------------------------------
  // COLUMNS for the Vendor Details grid — one entry per key returned by
  // /get_vendor_master_details. `group` drives the colored group-band row,
  // `width` (px) gives every header / filter box / cell a fixed size so the
  // sticky header, filter row and data all line up exactly; the table
  // scrolls horizontally instead of squeezing columns.
  // IMPORTANT: columns that share a group must stay next to each other in
  // this array, because the group band is built from consecutive columns.
  // ---------------------------------------------------------------------
  filterableColumns = [
    // Vendor
    { key: "venodrName", label: "Vendor Name", group: "Vendor", width: 220 },
    { key: "erpVendorCode", label: "ERP Vendor Code", group: "Vendor", width: 180 },
    { key: "vendorCode", label: "Vendor Code", group: "Vendor", width: 130 },

    // Tax Details
    { key: "vendorGstin", label: "GSTIN", group: "Tax Details", width: 170 },
    { key: "vendorPan", label: "PAN", group: "Tax Details", width: 130 },
    { key: "vendorTan", label: "TAN", group: "Tax Details", width: 130 },
    { key: "gstRegistrationType", label: "GST Registration Type", group: "Tax Details", width: 170 },
    { key: "residentFlag", label: "Resident", group: "Tax Details", width: 110 },
    { key: "thresholdLimitFlag", label: "TDS Threshold Limit", group: "Tax Details", width: 170 },
    { key: "section206ABFlag", label: "Section 206AB", group: "Tax Details", width: 130 },

    // Rates & Terms
    { key: "tdsPercentage", label: "TDS %", group: "Rates & Terms", width: 100 },
    { key: "tcsPercentage", label: "TCS %", group: "Rates & Terms", width: 100 },
    { key: "creditDays", label: "Credit Days", group: "Rates & Terms", width: 110 },

    // Contact
    { key: "contactName", label: "Contact Name", group: "Contact", width: 160 },
    { key: "contactNumber", label: "Contact Number", group: "Contact", width: 150 },
    { key: "vendorEmail", label: "Email", group: "Contact", width: 230 },

    // Address
    { key: "country", label: "Country", group: "Address", width: 120 },
    { key: "state", label: "State", group: "Address", width: 140 },
    { key: "address", label: "Address", group: "Address", width: 300 },

    // Purchase Manager
    { key: "purchaseManagerName", label: "Purchase Manager Name", group: "Purchase Manager", width: 200 },
    { key: "purchaseManagerContactNumber", label: "Purchase Manager Contact", group: "Purchase Manager", width: 210 },
    { key: "purchaseManagerEmail", label: "Purchase Manager Email", group: "Purchase Manager", width: 230 },

    // MSME
    { key: "msme", label: "MSME", group: "MSME", width: 100 },
    { key: "msme_reference", label: "MSME Reference", group: "MSME", width: 140 },
    { key: "msme_classification", label: "MSME Classification", group: "MSME", width: 170 },
    { key: "cin", label: "CIN", group: "MSME", width: 160 },

    // Entity
    { key: "entityGstin", label: "Entity GSTIN", group: "Entity", width: 170 },
    { key: "branchName", label: "Branch Name", group: "Entity", width: 240 },
    { key: "orgCode", label: "Org Code", group: "Entity", width: 100 },
    { key: "comments", label: "Comments", group: "Entity", width: 200 },
  ];

  // Trailing, display-only columns (not filterable) — still part of the
  // grouped header so the colored bands cover the full table width.
  nonFilterableColumns = [
    { key: "createDate", label: "Create Date", group: "Record Info", width: 170 },
    { key: "modifyDate", label: "Modify Date", group: "Record Info", width: 170 },
    { key: "created_date", label: "Created Date (System)", group: "Record Info", width: 190 },
    { key: "modified_date", label: "Modified Date (System)", group: "Record Info", width: 190 },
  ];

  // Fixed width (px) for the trailing sticky "SHOW" column.
  SHOW_COL_WIDTH = 70;

  // Fixed heights (px) of the two sticky header rows. The label row and the
  // filter row use these to compute their sticky `top` offsets, so the three
  // rows stack exactly with no gap or overlap.
  GROUP_ROW_HEIGHT = 30;
  LABEL_ROW_HEIGHT = 32;

  // Deep teal accent — same color used throughout the filter UI.
  ACCENT = "#0f766e";

  // Header colours — subtle tints of the app's navy (#03406f) on neutral greys.
  HEADER_GROUP_BG = "#e6ecf2";
  HEADER_LABEL_BG = "#f5f7f9";
  HEADER_TEXT = "#03406f";
  HEADER_BORDER = "#d3dce5";

  // Filter panel sections. Basic filters are open by default; every other
  // filterable column goes into the collapsed Advanced section.
  BASIC_FILTER_KEYS = [
    "venodrName",
    "erpVendorCode",
    "vendorCode",
    "vendorGstin",
    "vendorPan",
    "vendorTan",
    "gstRegistrationType",
    "country",
    "state",
  ];

  // Same value on every row of an entity, so filtering on them is useless.
  FILTER_EXCLUDED_KEYS = ["entityGstin", "branchName", "orgCode"];

  // Columns shown as a dropdown in the filter panel (values used by the
  // Add/Edit forms and seen in the response). Yes/No columns are dropdowns.
  FILTER_DROPDOWN_OPTIONS = {
    gstRegistrationType: [
      "Regular",
      "Unregistered",
      "Consumer",
      "Composition",
      "B2C",
      "Unknown",
    ],
    // Yes / No style columns
    section206ABFlag: ["Yes", "No"],
    msme: ["Yes", "No"],
    msme_reference: ["Yes", "No"],
    thresholdLimitFlag: ["Y", "N"],
    residentFlag: ["Resident", "Non Resident"],
  };

  getBasicFilterColumns = () =>
    this.BASIC_FILTER_KEYS.map((k) =>
      this.filterableColumns.find((c) => c.key === k)
    ).filter(Boolean);

  getAdvancedFilterColumns = () =>
    this.filterableColumns.filter(
      (c) =>
        !this.BASIC_FILTER_KEYS.includes(c.key) &&
        !this.FILTER_EXCLUDED_KEYS.includes(c.key)
    );

  getFieldMeta = (fieldKey) =>
    this.filterableColumns.find((c) => c.key === fieldKey) ||
    this.filterableColumns[0];

  // Color band per group.
  GROUP_COLORS = {
    "Vendor": "#0f766e",
    "Tax Details": "#7c3aed",
    "Rates & Terms": "#b45309",
    "Contact": "#0369a1",
    "Address": "#0e7490",
    "Purchase Manager": "#be185d",
    "MSME": "#4d7c0f",
    "Entity": "#1d4ed8",
    "Record Info": "#475569",
  };

  // Every column, filterable or not.
  allColumns = () => [...this.filterableColumns, ...this.nonFilterableColumns];

  // Distinct groups, in first-seen order, with how many columns each spans
  // — drives the top header row's colSpan per group band.
  getColumnGroups = () => {
    const groups = [];
    this.allColumns().forEach((col) => {
      const existing = groups.find((g) => g.name === col.group);
      if (existing) {
        existing.span += 1;
      } else {
        groups.push({ name: col.group, span: 1 });
      }
    });
    return groups;
  };

  // Total pixel width of every column belonging to a given group — used to
  // size the group-band <th> so it lines up exactly with the columns below it.
  getGroupWidth = (groupName) =>
    this.allColumns()
      .filter((c) => c.group === groupName)
      .reduce((sum, c) => sum + c.width, 0);

  // Sum of every column's width plus the sticky SHOW column — used as the
  // table's min-width so the horizontal scrollbar kicks in instead of the
  // browser squeezing columns to fit.
  getTableMinWidth = () =>
    this.allColumns().reduce((sum, c) => sum + c.width, this.SHOW_COL_WIDTH);

  // Splits a raw string on commas into trimmed, non-empty, de-duplicated
  // values. Used for every field's value box so a person can type or paste
  // "abc ltd, mr.gg, amazon" into one field and match any of them.
  parseBulkFilterValues = (raw) => {
    return Array.from(
      new Set(
        (raw || "")
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v.length > 0)
      )
    );
  };

  handleAutoSyncChange = (checked) => {
    this.setState({ autoSync: checked });
  };

  handlePageChange = (newPage) => {
    console.log('Page change requested:', newPage);
    this.setState({ page: newPage, loading: true }, () => {
      this.uploadReport(this.props.id, newPage, this.state.perPage);
    });
  };

  getIsCustVendorRequired = () => {
    axios
      .get(`/get_complete_entity_data/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        this.setState({
          isCustVendorRequired: res.data.Entity.is_cust_vendor_required,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleNextPage = (event) => {
    const { errorPage, perErrorPages, errortotal } = this.state;
    const totalPages = Math.ceil(errortotal / perErrorPages);

    if (errorPage < totalPages) {
      const newPage = errorPage + 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handlePreviousPage = (event) => {
    const { errorPage } = this.state;

    if (errorPage > 1) {
      const newPage = errorPage - 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handleRowsPerPageChange = (index, value) => {
    console.log(`Changing rows per page to ${value}`);
    this.setState(
      {
        perErrorPages: value,
        errorPage: 1,
      },
      () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, 1);
      }
    );
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          newPage,
          this.state.rowsPerPage
        );
      } else {
        this.getPurchaseDataApi(event, this.state.searchInput);
      }
    });
  };

  handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    this.setState({ rowsPerPage: newRowsPerPage, page: 0 }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          0,
          newRowsPerPage
        );
      } else {
        this.getPurchaseDataApi(event, this.state.searchInput);
      }
    });
  };

  // table serach
  handleSearchInputChange = (event) => {
    this.setState({ searchInput: event.target.value, page: 0 }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        );
      } else {
        this.getPurchaseDataApi(event, this.state.searchInput);
      }
    });
  };

  openModal = (index) => {
    this.setState(
      {
        targetId: index,
      },
      () => {
        this.setState({
          effitracInvShow: true,
        });
      }
    );
  };

  closeEffitracInvShowHandler = () => {
    this.setState({
      effitracInvShow: false,
      targetId: null,
    });
  };

  getPurchaseDataApi = (event, serachIn) => {
    axios
      .post(`/get_vendor_master_details`, {
        number_of_rows_per_page: this.state.rowsPerPage,
        page_number: this.state.page,
        search_text: serachIn,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          allArcCustomerDataPurchase: res.data.record,
          OriginalDataAllArcCustomerDataPurchase: res.data.record,
          rowCount: res.data.row_count,
          loaderForVendorMgmt: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Filter API call — takes the { match_type, conditions } payload built by
  // applyDynamicFilters and posts it ONCE for all active conditions, along
  // with pagination. NOTE: change the URL below if your backend route differs.
  getPurchaseDataFilterApi = (
    filters = {},
    page = this.state.page,
    rowsPerPage = this.state.rowsPerPage
  ) => {
    this.setState({ loaderForVendorMgmt: true, activeFilters: filters });

    axios
      .post(`/get_vendor_master_detailsFilter`, {   // ← change URL if your route is different
        business_entity_id: localStorage.getItem("business_entity_id"),
        search_text: this.state.searchInput || "",
        filters: filters,
        number_of_rows_per_page: rowsPerPage,
        page_number: page,
      })
      .then((res) => {
        this.setState({
          allArcCustomerDataPurchase: res.data.record || [],
          OriginalDataAllArcCustomerDataPurchase: res.data.record || [],
          rowCount: res.data.row_count || 0,
          loaderForVendorMgmt: false,
          page: page,
          rowsPerPage: rowsPerPage,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loaderForVendorMgmt: false });
        toast.error("Failed to fetch filtered data");
      });
  };

  // -----------------------------------------------------------------------
  // IN-GRID MULTI-FIELD FILTER
  // -----------------------------------------------------------------------
  // Every filterable column has its own compact box directly in the filter
  // row under the table header. Typing into several boxes at once stages
  // several conditions; nothing is sent to the backend until "Apply" (or
  // Enter) fires ONCE for the whole set.

  // Patches one column's staged (not-yet-applied) value.
  handleInlineFilterChange = (field, rawValue) => {
    this.setState((prevState) => ({
      inlineFilterValues: {
        ...prevState.inlineFilterValues,
        [field]: rawValue,
      },
    }));
  };

  getInlineFilterValue = (field) => this.state.inlineFilterValues[field] ?? "";

  // Clears just one column's box (its little "×" adornment), without
  // touching any other staged column or applying anything.
  clearInlineFilterField = (field) => {
    this.setState((prevState) => ({
      inlineFilterValues: { ...prevState.inlineFilterValues, [field]: "" },
    }));
  };

  // True once at least one column box has something typed into it that
  // hasn't been applied yet — drives the "Apply Filters" affordance.
  hasStagedFilterChanges = () => {
    const { inlineFilterValues, appliedFilters } = this.state;
    const appliedByField = Object.fromEntries(
      appliedFilters.map((c) => [c.field, c.value])
    );
    return this.filterableColumns.some((col) => {
      const staged = (inlineFilterValues[col.key] ?? "").trim();
      const applied = (appliedByField[col.key] ?? "").trim();
      return staged !== applied;
    });
  };

  stagedFilterFieldCount = () =>
    Object.values(this.state.inlineFilterValues).filter(
      (v) => (v ?? "").toString().trim() !== ""
    ).length;

  // Single action: reads every column's box, keeps only the ones with a
  // value, and fires ONE api call for the combined set.
  applyInlineFilters = () => {
    const conditions = this.filterableColumns
      .map((col) => ({
        field: col.key,
        value: (this.state.inlineFilterValues[col.key] ?? "").trim(),
      }))
      .filter((c) => c.value !== "");

    this.setState({ appliedFilters: conditions, page: 0 }, () =>
      this.applyDynamicFilters(
        conditions,
        this.state.filterMatchType,
        0,
        this.state.rowsPerPage
      )
    );
  };

  // Wipes every column's box and whatever was applied, in one shot.
  handleClearAllFilters = () => {
    this.setState(
      { inlineFilterValues: {}, draftValues: {}, appliedFilters: [], page: 0 },
      () =>
        this.applyDynamicFilters([], this.state.filterMatchType, 0, this.state.rowsPerPage)
    );
  };

  // -----------------------------------------------------------------------
  // COMMON FILTER PANEL — state handlers
  // -----------------------------------------------------------------------

  // The Filter button toggles the panel. When opening, the panel is
  // pre-filled with whatever is currently applied so the person always
  // sees what is live.
  openFilterPanel = () => {
    if (this.state.filterPanelOpen) {
      this.setState({ filterPanelOpen: false });
      return;
    }
    const draftValues = {};
    this.state.appliedFilters.forEach((c) => {
      draftValues[c.field] = c.value;
    });
    this.setState({ filterPanelOpen: true, draftValues });
  };

  // Closing without pressing "Apply Filters" discards unapplied edits.
  closeFilterPanel = () => {
    this.setState({ filterPanelOpen: false });
  };

  toggleAdvancedFilters = () => {
    this.setState((prev) => ({ advancedFiltersOpen: !prev.advancedFiltersOpen }));
  };

  // Chip cross: removes ONE applied filter and reloads the table.
  removeAppliedFilter = (field) => {
    const conditions = this.state.appliedFilters.filter((c) => c.field !== field);
    this.setState(
      (prev) => {
        const draftValues = { ...prev.draftValues };
        delete draftValues[field];
        const inlineFilterValues = { ...prev.inlineFilterValues };
        delete inlineFilterValues[field];
        return { appliedFilters: conditions, draftValues, inlineFilterValues, page: 0 };
      },
      () =>
        this.applyDynamicFilters(
          conditions,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  handleDraftValueChange = (key) => (event) => {
    const value = event.target.value;
    this.setState((prev) => ({
      draftValues: { ...prev.draftValues, [key]: value },
    }));
  };

  // Excel copy-paste brings multiple values separated by newlines (rows) or
  // tabs (columns), with no commas. Convert that shape into the same
  // comma-separated "is any of" format, appending to whatever is typed.
  handleFilterValuePaste = (key) => (e) => {
    const pasted = e.clipboardData.getData("text");
    if (!pasted || !/[\r\n\t]/.test(pasted)) return; // single value — default paste

    e.preventDefault();
    const joined = pasted
      .split(/[\r\n\t]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0)
      .join(", ");
    if (!joined) return;

    this.setState((prev) => {
      const current = (prev.draftValues[key] || "").replace(/\s+$/, "");
      const next = !current
        ? joined
        : current.endsWith(",")
        ? `${current} ${joined}`
        : `${current}, ${joined}`;
      return { draftValues: { ...prev.draftValues, [key]: next } };
    });
  };

  // Enter inside any input applies the filter.
  handleFilterKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.applyFilterFromPanel();
    }
  };

  // "Apply Filters" — every non-empty input becomes a condition, and the
  // whole set is sent in ONE api call. The panel closes afterwards.
  applyFilterFromPanel = () => {
    const conditions = [
      ...this.getBasicFilterColumns(),
      ...this.getAdvancedFilterColumns(),
    ]
      .map((c) => ({
        field: c.key,
        value: (this.state.draftValues[c.key] || "").trim(),
      }))
      .filter((c) => c.value !== "");

    this.setState(
      { appliedFilters: conditions, filterPanelOpen: false, page: 0 },
      () =>
        this.applyDynamicFilters(
          conditions,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  // Builds the backend payload from the current conditions and either calls
  // the filter API (when conditions exist) or falls back to the normal
  // paginated listing (when the filter set is empty). Every condition is
  // sent as operator "in" — "field value is any of these".
  applyDynamicFilters = (
    conditions = this.state.appliedFilters,
    matchType = this.state.filterMatchType,
    page = 0,
    rowsPerPage = this.state.rowsPerPage
  ) => {
    if (!conditions || conditions.length === 0) {
      this.setState({ activeFilters: null });
      this.getPurchaseDataApi(null, this.state.searchInput);
      return;
    }

    const payload = conditions.map((c) => ({
      field: c.field,
      operator: "in",
      value: this.parseBulkFilterValues(c.value),
    }));

    const filters = { match_type: matchType, conditions: payload };
    this.setState({ activeFilters: filters });
    this.getPurchaseDataFilterApi(filters, page, rowsPerPage);
  };

  getSellercustomerLastUploadDate = () => {
    const customer = "Seller Customer";
    axios
      .get(
        `/get_last_update_date/${localStorage.getItem(
          "business_entity_id"
        )}/${customer}`
      )
      .then((res) => {
        const d = res.data.last_updated_date.split("T");
        const Date = indianFormat(d[0]);
        const Time = d[1].split("Z");
        this.setState({
          lastUploadDate: Date,
          lastUploadTime: Time,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getApiForClientID = () => {
    axios
      .get(`/connection_info/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        console.log(res.data);
        res.data.record
          .filter((v) => v.source_system === "ZOHO")
          .map((value) =>
            localStorage.setItem("Client_ID", value.connection_info.client_id)
          );
        res?.data?.record.filter((v) => {
          if (v.source_system === "Effitrac" || v.source_system === "Tally") {
            localStorage.setItem("Trigger_Effitrac/Tally_Button", "true");
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getHistoryTableUploadData = () => {
    axios
      .get(
        `/arc/get_data_upload_history/${localStorage.getItem(
          "business_entity_id"
        )}/${11}`
      )
      .then((res) => {
        this.setState({ uploadHistoryTableData: res.data.record });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidMount() {
    let domain = new URL(window.location).searchParams;
    let code = domain.get("code");
    code && this.setState({ grantToken: code });

    let drawer = domain.get("drawer");
    drawer &&
      this.setState({
        openZohoDrawer: true,
        messageForConnection: "Connection Established",
        buttonColor: "green",
      });

    let url = window.location;
    this.setState({ url: url.origin });
    localStorage.setItem("urlOrigin", url.origin);
    localStorage.setItem("pathName", url.pathname);
    console.log(url.pathname);

    this.getApiForClientID();
    this.getPurchaseDataApi();
    this.getSellercustomerLastUploadDate();
    this.getHistoryTableUploadData();
    this.getErpConnectorName();
    this.getIsCustVendorRequired();
  }

  componentWillUnmount() {
    if (variableForTimerForZoho) {
      clearInterval(variableForTimerForZoho);
    }
  }

  getErpConnectorName = () => {
    axios.get(`/arc/verify_erp_data_pull_eligibility/${localStorage.getItem('business_entity_id')}`)
      .then((res) => {
        if (res?.data?.status) {
          this.setState({ erpConnectorName: res?.data?.data })
        }
      }).catch((err) => {

      })
  }

  componentDidUpdate() {
    if (this.state.buttonColor === "green" && !this.state.flagForZoho) {
      this.setState({ flagForZoho: true });
      variableForTimerForZoho = setInterval(() => {
        console.log("run");
        this.setState((prevstate) => ({
          timerForZoho: prevstate.timerForZoho - 1,
        }));
      }, 1000);
    }

    if (this.state.timerForZoho === 0) {
      clearInterval(variableForTimerForZoho);
      this.setState({
        flagForZoho: false,
        timerForZoho: 60,
        buttonColor: "red",
      });
    }
  }

  //Search field---
  handleSearchInputChangeFroEffitrackAndZoho = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch(event);
    });
  };

  globalSearch = (event) => {
    let { searchInput } = this.state;
    let searchAdminData = this.state.oldEffitracData.filter((value) => {
      const query = searchInput.trim().toLowerCase();
      return (
        String(value.erpVendorCode).toLowerCase().indexOf(query) >= 0 ||
        String(value.venodrName).toLowerCase().indexOf(query) >= 0 ||
        String(value.vendorGstin).toLowerCase().indexOf(query) >= 0 ||
        String(value.vendorPan).toLowerCase().indexOf(query) >= 0 ||
        String(value.vendorTan).toLowerCase().indexOf(query) >= 0 ||
        String(value.tdsPercentage).toLowerCase().indexOf(query) >= 0
      );
    });
    this.setState({ effitracData: searchAdminData });
  };
  // End---

  //file upload handler---
  fileUploader = (event, serachIn) => {
    this.setState({ loading: true });
    const file_data = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file_data);

    let dis = this;
    reader.onload = function () {
      let file_value = reader.result;
      axios
        .post(`/vendor/vendormaster`, {
          file: file_value,
          org_code: localStorage.getItem("business_entity_id"),
        })
        .then((data) => {
          if (!data || !data.data) {
            dis.setState({ loading: false });
            return;
          }

          dis.getHistoryTableUploadData();
          dis.setState({ loading: false });
        })
        .catch((error) => {
          dis.setState({ loading: false });
          const errorMessage = error?.response?.data?.message;
          if (errorMessage) {
            toast.error(errorMessage, { autoClose: 5000 });
          }
        });
    };
  };

  refreshUploadHistoryTable = () => {
    this.getHistoryTableUploadData();
    this.getPurchaseDataApi();
  };

  // file upload button---
  CollectionListActions = () => (
    <div>
      <a
        href={VenderMaster}
        download={"vendor_management.xlsx"}
        style={{ textDecoration: "none" }}
      >
        {" "}
        <Button component="label" size="small" color="primary">
          <GetAppIcon style={{ fontSize: "20px" }} />
          DOWNLOAD TEMPLATE
        </Button>
      </a>

      {this.state.isCustVendorRequired && canWrite("UPLOADING PURCHASE") && (
      <Button component="label" size="small" color="primary">
        <PublishIcon style={{ fontSize: "20px" }} />
        UPLOAD TEMPLATE{" "}
        <input
          accept=".xlsx"
          name="file"
          type="file"
          value=""
          hidden
          onChange={this.fileUploader}
        />
      </Button>
      )}

      <Button
        component="label"
        size="small"
        color="primary"
        style={{ float: "right" }}
        onClick={this.refreshUploadHistoryTable}
      >
        <RefreshIcon style={{ fontSize: "20px" }} />
        Refresh
      </Button>
    </div>
  );

  // -----------------------------------------------------------------------
  // IN-GRID FILTER — rendering (kept for reference; the table now uses the
  // common Filter panel below, so these two are no longer called)
  // -----------------------------------------------------------------------
  // The slim bar directly above the table. Returns null when there is
  // nothing to show (no applied filters, nothing staged) so it never adds
  // visual weight to the page until it's actually useful.
  renderFilterActionBar = () => {
    const stagedCount = this.stagedFilterFieldCount();
    const hasStaged = this.hasStagedFilterChanges();
    const hasApplied = this.state.appliedFilters.length > 0;

    if (!hasStaged && !hasApplied) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
          padding: "7px 14px",
          marginBottom: "6px",
          borderRadius: "8px",
          background: hasStaged
            ? `linear-gradient(90deg, ${this.ACCENT}, #115e59)`
            : "#f1f5f9",
          color: hasStaged ? "#ffffff" : "#334155",
          transition: "background 0.2s ease",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "12.5px" }}>
          <TuneIcon style={{ fontSize: "16px" }} />
          <span>
            {hasStaged
              ? `${stagedCount} field${stagedCount === 1 ? "" : "s"} ready to filter`
              : `${this.state.appliedFilters.length} filter${
                  this.state.appliedFilters.length === 1 ? "" : "s"
                } active`}
          </span>
        </div>

        <div style={{ display: "flex", gap: "14px", alignItems: "center" }}>
          {hasApplied && (
            <button
              type="button"
              onClick={this.handleClearAllFilters}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "12px",
                cursor: "pointer",
                color: hasStaged ? "rgba(255,255,255,0.9)" : this.ACCENT,
                textDecoration: "underline",
              }}
            >
              Clear all
            </button>
          )}
          {hasStaged && (
            <button
              type="button"
              onClick={this.applyInlineFilters}
              style={{
                background: "#ffffff",
                color: this.ACCENT,
                border: "none",
                borderRadius: "999px",
                padding: "4px 18px",
                fontSize: "12px",
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
              }}
            >
              Apply Filters
            </button>
          )}
        </div>
      </div>
    );
  };

  // -----------------------------------------------------------------------
  // COMMON FILTER PANEL — rendering
  // -----------------------------------------------------------------------
  // 1) renderFilterButton: one "Filter" button with a funnel icon (shows
  //    "Filter (n)" when filters are active). It toggles the panel.
  // 2) renderFilterPanel: a compact side panel that sits NEXT TO the table
  //    inside the same flex row (not position: fixed). Header "Filters" +
  //    close icon, Basic Filters (open), Advanced Filters (collapsed, with a
  //    count), footer with Clear All / Apply Filters.
  // 3) renderAppliedFilterChips: one chip per applied filter, each with its
  //    own cross.

  renderFilterButton = () => {
    const appliedCount = this.state.appliedFilters.length;
    return (
      <button
        type="button"
        className="button-outlined-primary"
        onClick={this.openFilterPanel}
        style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
      >
        <FilterAltOutlinedIcon style={{ fontSize: "18px" }} />
        {appliedCount > 0 ? `Filter (${appliedCount})` : "Filter"}
      </button>
    );
  };

  // One label + white input (dropdown for the columns in FILTER_DROPDOWN_OPTIONS).
  renderFilterField = (col) => {
    const { draftValues } = this.state;
    const common = {
      fullWidth: true,
      size: "small",
      variant: "outlined",
      value: draftValues[col.key] ?? "",
      onChange: this.handleDraftValueChange(col.key),
      InputProps: { style: { background: "#fff" } },
    };
    const options = this.FILTER_DROPDOWN_OPTIONS[col.key];

    return (
      <div key={col.key} style={{ minWidth: 0 }}>
        <label style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}>
          {col.label}
        </label>
        {options ? (
          <TextField {...common} select SelectProps={{ native: true }}>
            <option value="">Select</option>
            {options.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </TextField>
        ) : (
          <TextField
            {...common}
            placeholder={`Enter ${col.label.toLowerCase()}`}
            onPaste={this.handleFilterValuePaste(col.key)}
            onKeyDown={this.handleFilterKeyDown}
          />
        )}
      </div>
    );
  };

  renderFilterPanel = () => {
    const { filterPanelOpen, draftValues, advancedFiltersOpen } = this.state;
    if (!filterPanelOpen) return null;

    const advancedColumns = this.getAdvancedFilterColumns();
    const advancedCount = advancedColumns.filter(
      (c) => (draftValues[c.key] || "").trim() !== ""
    ).length;

    const gridStyle = {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
    };

    return (
      <div
        style={{
          width: 440,
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          minHeight: 360,
          // Keeps the panel table-sized; the body scrolls inside.
          maxHeight: "calc(100vh - 260px)",
          border: `1px solid ${this.HEADER_TEXT}`,
          borderRadius: 4,
          background: "#fff",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(3,64,111,0.12)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "6px 6px 6px 14px",
            background: this.HEADER_TEXT,
            color: "#ffffff",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: 600 }}>Filters</span>
          <Tooltip title="Close" arrow>
            <IconButton size="small" onClick={this.closeFilterPanel}>
              <ClearIcon style={{ fontSize: "16px", color: "#ffffff" }} />
            </IconButton>
          </Tooltip>
        </div>

        {/* Body: Basic (open) + Advanced (collapsed) */}
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            padding: "12px 14px",
            background: "#eef3f8",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              marginBottom: "10px",
            }}
          >
            Basic Filters
          </div>
          <div style={gridStyle}>
            {this.getBasicFilterColumns().map((col) => this.renderFilterField(col))}
          </div>

          <div
            role="button"
            onClick={this.toggleAdvancedFilters}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              marginTop: "14px",
              padding: "10px 0",
              borderTop: `1px solid ${this.HEADER_BORDER}`,
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              userSelect: "none",
            }}
          >
            <span>
              {advancedCount > 0
                ? `Advanced Filters (${advancedCount})`
                : "Advanced Filters"}
            </span>
            {advancedFiltersOpen ? (
              <ExpandLessIcon style={{ fontSize: "20px" }} />
            ) : (
              <ExpandMoreIcon style={{ fontSize: "20px" }} />
            )}
          </div>
          {advancedFiltersOpen && (
            <div style={gridStyle}>
              {advancedColumns.map((col) => this.renderFilterField(col))}
            </div>
          )}
        </div>

        {/* Footer — bottom right */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "10px 14px",
            background: this.HEADER_GROUP_BG,
            borderTop: `1px solid ${this.HEADER_BORDER}`,
          }}
        >
          <button
            type="button"
            className="button-outlined-secondary"
            onClick={this.handleClearAllFilters}
          >
            Clear All
          </button>
          <button
            type="button"
            className="button-primary"
            onClick={this.applyFilterFromPanel}
          >
            Apply Filters
          </button>
        </div>
      </div>
    );
  };

  // Applied filters as small chips, each with its own cross.
  renderAppliedFilterChips = () => {
    const { appliedFilters } = this.state;
    if (appliedFilters.length === 0) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          marginBottom: "8px",
        }}
      >
        {appliedFilters.map((c) => (
          <Chip
            key={c.field}
            size="small"
            variant="outlined"
            label={`${this.getFieldMeta(c.field).label}: ${c.value}`}
            onDelete={() => this.removeAppliedFilter(c.field)}
            style={{
              maxWidth: 280,
              backgroundColor: this.HEADER_GROUP_BG,
              color: this.HEADER_TEXT,
              borderColor: this.HEADER_BORDER,
            }}
          />
        ))}
      </div>
    );
  };

  // -----------------------------------------------------------------------
  // GROUPED HEADER — returns an array of TWO <tr> elements:
  //   1) the group-band row, each band spanning all of its columns via
  //      colSpan and sized to the total width of its columns, plus the
  //      trailing SHOW cell which spans both header rows
  //   2) the column-label row
  // The caller drops the array straight into <tbody> (NOT inside another
  // <tr>). Both rows have fixed heights so the sticky offsets of the label
  // row and the filter row stack exactly. Colours are now the subtle navy /
  // neutral tints (HEADER_*) instead of the bright group colours.
  // -----------------------------------------------------------------------
  arc_Customer_TableHeader() {
    const groups = this.getColumnGroups();

    const groupRow = (
      <tr key="group-row">
        {groups.map((g) => {
          const width = this.getGroupWidth(g.name);
          return (
            <th
              key={g.name}
              colSpan={g.span}
              style={{
                position: "sticky",
                top: 0,
                zIndex: 510,
                height: this.GROUP_ROW_HEIGHT,
                lineHeight: "18px",
                width: width,
                minWidth: width,
                maxWidth: width,
                padding: "6px 8px",
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                color: this.HEADER_TEXT,
                background: this.HEADER_GROUP_BG,
                textAlign: "center",
                borderRight: `1px solid ${this.HEADER_BORDER}`,
                borderBottom: `1px solid ${this.HEADER_BORDER}`,
                whiteSpace: "nowrap",
                boxSizing: "border-box",
              }}
            >
              {g.name}
            </th>
          );
        })}
        <th
          rowSpan={2}
          style={{
            position: "sticky",
            top: 0,
            right: 0,
            zIndex: 520,
            width: this.SHOW_COL_WIDTH,
            minWidth: this.SHOW_COL_WIDTH,
            maxWidth: this.SHOW_COL_WIDTH,
            backgroundColor: this.HEADER_GROUP_BG,
            color: this.HEADER_TEXT,
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.4px",
            textTransform: "uppercase",
            textAlign: "center",
            verticalAlign: "middle",
            borderLeft: `1px solid ${this.HEADER_BORDER}`,
            borderBottom: `1px solid ${this.HEADER_BORDER}`,
            boxShadow: "-2px 0 4px rgba(0,0,0,0.06)",
            boxSizing: "border-box",
          }}
        >
          SHOW
        </th>
      </tr>
    );

    const labelRow = (
      <tr key="label-row">
        {this.allColumns().map((col) => (
          <th
            key={col.key}
            title={col.label}
            style={{
              position: "sticky",
              top: this.GROUP_ROW_HEIGHT,
              zIndex: 500,
              height: this.LABEL_ROW_HEIGHT,
              lineHeight: "18px",
              width: col.width,
              minWidth: col.width,
              maxWidth: col.width,
              backgroundColor: this.HEADER_LABEL_BG,
              padding: "6px 8px",
              fontSize: "11.5px",
              fontWeight: 600,
              color: "#334155",
              textAlign: "center",
              borderRight: `1px solid ${this.HEADER_BORDER}`,
              borderBottom: `1px solid ${this.HEADER_BORDER}`,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              boxSizing: "border-box",
            }}
          >
            {col.label.toUpperCase()}
          </th>
        ))}
      </tr>
    );

    return [groupRow, labelRow];
  }

  // The old in-grid filter row (kept for reference; no longer rendered —
  // the common Filter panel replaces it).
  renderInlineFilterRow = () => {
    const filterRowTop = this.GROUP_ROW_HEIGHT + this.LABEL_ROW_HEIGHT;
    const appliedByField = Object.fromEntries(
      this.state.appliedFilters.map((c) => [c.field, c.value])
    );

    return (
      <tr>
        {this.filterableColumns.map((col) => {
          const value = this.getInlineFilterValue(col.key);
          const isApplied =
            value.trim() !== "" && (appliedByField[col.key] ?? "").trim() === value.trim();

          return (
            <td
              key={col.key}
              style={{
                position: "sticky",
                top: filterRowTop,
                zIndex: 400,
                width: col.width,
                minWidth: col.width,
                maxWidth: col.width,
                padding: "6px 10px",
                background: "#f0fdfa",
                borderBottom: `2px solid ${isApplied ? this.ACCENT : "#d9e6e4"}`,
                boxSizing: "border-box",
              }}
            >
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <input
                  type="text"
                  value={value}
                  onChange={(e) => this.handleInlineFilterChange(col.key, e.target.value)}
                  onPaste={(e) => {
                    // Excel copy-paste brings multiple values separated by
                    // newlines (one per row) or tabs (one per column), with
                    // no commas at all. Detect that shape and convert it
                    // into the same comma-separated "is any of" format this
                    // box expects, appending to whatever is already typed.
                    const pasted = e.clipboardData.getData("text");
                    if (!pasted || !/[\r\n\t]/.test(pasted)) return; // plain single-value paste — let default happen

                    e.preventDefault();
                    const pastedValues = pasted
                      .split(/[\r\n\t]+/)
                      .map((v) => v.trim())
                      .filter((v) => v.length > 0);
                    if (pastedValues.length === 0) return;

                    const joined = pastedValues.join(", ");
                    const current = value.replace(/\s+$/, "");
                    const newValue =
                      current === ""
                        ? joined
                        : current.endsWith(",")
                        ? `${current} ${joined}`
                        : `${current}, ${joined}`;

                    this.handleInlineFilterChange(col.key, newValue);
                  }}
                  onKeyDown={(e) => {
                    // Enter applies every staged box at once — same effect
                    // as clicking "Apply Filters" in the bar above.
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.applyInlineFilters();
                    }
                  }}
                  placeholder={`e.g. ${col.label.toLowerCase()} 1, 2`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "transparent",
                    outline: "none",
                    fontSize: "12px",
                    fontFamily: "inherit",
                    padding: "3px 18px 3px 2px",
                    color: "#0f172a",
                    textAlign: "center",
                  }}
                />
                {value && (
                  <ClearIcon
                    onClick={() => this.clearInlineFilterField(col.key)}
                    style={{
                      position: "absolute",
                      right: 0,
                      fontSize: "14px",
                      color: "#94a3b8",
                      cursor: "pointer",
                    }}
                  />
                )}
              </div>
            </td>
          );
        })}
        {this.nonFilterableColumns.map((col) => (
          <td
            key={`${col.key}_filter`}
            style={{
              position: "sticky",
              top: filterRowTop,
              zIndex: 400,
              width: col.width,
              minWidth: col.width,
              maxWidth: col.width,
              background: "#f0fdfa",
              borderBottom: "2px solid #d9e6e4",
              boxSizing: "border-box",
            }}
          />
        ))}
        <td
          style={{
            position: "sticky",
            top: filterRowTop,
            right: 0,
            zIndex: 410,
            width: this.SHOW_COL_WIDTH,
            minWidth: this.SHOW_COL_WIDTH,
            maxWidth: this.SHOW_COL_WIDTH,
            padding: "6px 10px",
            background: "#f0fdfa",
            borderBottom: "2px solid #d9e6e4",
            textAlign: "center",
            boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
            boxSizing: "border-box",
          }}
        >
          {this.state.appliedFilters.length > 0 && (
            <Tooltip title="Clear all filters">
              <IconButton size="small" onClick={this.handleClearAllFilters}>
                <ClearIcon style={{ fontSize: "16px", color: this.ACCENT }} />
              </IconButton>
            </Tooltip>
          )}
        </td>
      </tr>
    );
  };

  arc_Customer__data() {
    const showToggleDrawer = (
      purchaseManagerEmail,
      vendorEmail,
      residentFlag,
      gstRegistrationType,
      address,
      created_date,
      contactNumber,
      purchaseManagerName,
      vendorPan,
      comments,
      vendorCode,
      country,
      state,
      creditDays,
      thresholdLimitFlag,
      erpVendorCode,
      modified_date,
      vendorGstin,
      venodrName,
      purchaseManagerContactNumber,
      vendorTan,
      contactName,
      tdsPercentage,
      tcsPercentage,
      orgCode,
      section206ABFlag
    ) => {
      this.setState({
        showData: {
          address: address,
          contactName: contactName,
          contactNumber: contactNumber,
          vendorEmail: vendorEmail,
          vendorPan: vendorPan,
          vendorTan: vendorTan,
          purchaseManagerName: purchaseManagerName,
          purchaseManagerContactNumber: purchaseManagerContactNumber,
          purchaseManagerEmail: purchaseManagerEmail,
          creditDays: creditDays,
          gstRegistrationType: gstRegistrationType,
          tcsPercentage: tcsPercentage,
          thresholdLimitFlag: thresholdLimitFlag,
          residentFlag: residentFlag,
          comments: comments,
          create_date: created_date,
          modify_date: modified_date,
          country: country,
          state: state,
          section206ABFlag: section206ABFlag,
        },
        showDrawer: true,
      });
    };
    // edit ----
    const editARCCustomer = (
      purchaseManagerEmail,
      vendorEmail,
      residentFlag,
      gstRegistrationType,
      address,
      created_date,
      contactNumber,
      purchaseManagerName,
      vendorPan,
      comments,
      vendorCode,
      country,
      state,
      creditDays,
      thresholdLimitFlag,
      erpVendorCode,
      modified_date,
      vendorGstin,
      venodrName,
      purchaseManagerContactNumber,
      vendorTan,
      contactName,
      tdsPercentage,
      tcsPercentage,
      orgCode,
      section206ABFlag
    ) => {
      this.setState({
        editCustomerData: {
          venodrName: venodrName,
          erpVendorCode: erpVendorCode,
          country: country,
          state: state,
          address: address,
          contactName: contactName,
          contactNumber: contactNumber,
          vendorEmail: vendorEmail,
          vendorGstin: vendorGstin,
          vendorPan: vendorPan,
          vendorTan: vendorTan,

          purchaseManagerName: purchaseManagerName,
          purchaseManagerContactNumber: purchaseManagerContactNumber,
          purchaseManagerEmail: purchaseManagerEmail,
          creditDays: creditDays,
          gstRegistrationType: gstRegistrationType,

          tcsPercentage: tcsPercentage,
          tdsPercentage: tdsPercentage,

          thresholdLimitFlag: thresholdLimitFlag,
          residentFlag: residentFlag,
          comments: comments,
          section206ABFlag: section206ABFlag,
        },
        edit_DrawerOpen: true,
      });
    };

    // Every cell renders as-is, falling back to "-" when empty, so adding or
    // reordering a column in `filterableColumns` / `nonFilterableColumns` is
    // enough to update the header, filter row and body together.
    const renderCellValue = (col, tableData) => {
      const raw = tableData[col.key];
      return raw !== null && raw !== undefined && raw !== "" ? raw : "-";
    };

    if (
      this.state.allArcCustomerDataPurchase &&
      this.state.allArcCustomerDataPurchase.length >= 1
    ) {
      return this.state.allArcCustomerDataPurchase.map((tableData, index) => {
        const {
          purchaseManagerEmail,
          vendorEmail,
          residentFlag,
          gstRegistrationType,
          address,
          created_date,
          contactNumber,
          purchaseManagerName,
          vendorPan,
          comments,
          vendorCode,
          country,
          state,
          creditDays,
          thresholdLimitFlag,
          erpVendorCode,
          modified_date,
          vendorGstin,
          venodrName,
          purchaseManagerContactNumber,
          vendorTan,
          contactName,
          tdsPercentage,
          tcsPercentage,
          orgCode,
          section206ABFlag,
        } = tableData; //destructuring
        return (
          <tr key={index}>
            {this.allColumns().map((col) => {
              const cellValue = renderCellValue(col, tableData);
              return (
                <td
                  key={col.key}
                  title={String(cellValue)}
                  style={{
                    width: col.width,
                    minWidth: col.width,
                    maxWidth: col.width,
                    borderRight: "1px solid #f1f5f9",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    padding: "6px 10px",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                >
                  {cellValue}
                </td>
              );
            })}
            {/* <td>
              <Button
                size="small"
                variant="outlined"
                onClick={() =>
                  editARCCustomer(
                    purchaseManagerEmail,
                    vendorEmail,
                    residentFlag,
                    gstRegistrationType,
                    address,
                    createDate,
                    contactNumber,
                    purchaseManagerName,
                    vendorPan,
                    comments,
                    vendorCode,
                    country,
                    state,
                    creditDays,
                    thresholdLimitFlag,
                    erpVendorCode,
                    modifyDate,
                    vendorGstin,
                    venodrName,
                    purchaseManagerContactNumber,
                    vendorTan,
                    contactName,
                    tdsPercentage,
                    tcsPercentage,
                    orgCode,
                    section206ABFlag
                  )
                }
              >
                edit
              </Button>
            </td> */}
            <td
              style={{
                position: "sticky",
                right: 0,
                zIndex: 300,
                width: this.SHOW_COL_WIDTH,
                minWidth: this.SHOW_COL_WIDTH,
                maxWidth: this.SHOW_COL_WIDTH,
                background: "#fff",
                textAlign: "center",
                boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
                boxSizing: "border-box",
              }}
            >
              <RemoveRedEyeOutlinedIcon
                className="action-icon-button showIcon"
                onClick={() =>
                  showToggleDrawer(
                    purchaseManagerEmail,
                    vendorEmail,
                    residentFlag,
                    gstRegistrationType,
                    address,
                    created_date,
                    contactNumber,
                    purchaseManagerName,
                    vendorPan,
                    comments,
                    vendorCode,
                    country,
                    state,
                    creditDays,
                    thresholdLimitFlag,
                    erpVendorCode,
                    modified_date,
                    vendorGstin,
                    venodrName,
                    purchaseManagerContactNumber,
                    vendorTan,
                    contactName,
                    tdsPercentage,
                    tcsPercentage,
                    orgCode,
                    section206ABFlag
                  )
                }
              />
            </td>
          </tr>
        );
      });
    } else if (this.state.loaderForVendorMgmt) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={this.allColumns().length + 1}
          >
            Loading...Please wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={this.allColumns().length + 1}>
            {this.state.appliedFilters.length > 0 ? (
              <>
                No records found for the selected filters.{" "}
                <span
                  role="button"
                  onClick={this.handleClearAllFilters}
                  style={{
                    color: this.HEADER_TEXT,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Clear filters
                </span>
              </>
            ) : (
              "No data found!"
            )}
          </td>
        </tr>
      );
    }
  }
  // -------------------------------------arc customer table end---------------------------

  // show drawer close handler---
  showToggleDrawerClose = (event) => {
    this.setState({ showDrawer: false });
  };

  // file upload response data handler---
  closeUploadData = () => {
    this.setState({ showUploadData: false });
    this.getPurchaseDataApi();
  };
  // ------------------------add customer-----------------------
  // add customer[add button] drawer open handeler---
  addCustomer_drawerOpen = () => {
    this.setState({ add_DrawerOpen: true });
  };

  // add customer inputfield handler---
  addCustomer_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "tdsPercentage" || name === "tcsPercentage") {
      if (value > 100)
        if (name === "tdsPercentage") {
          this.setState({ buttonDisabled: true });
        } else {
          this.setState({ buttonDisabled: true });
        }
      else {
        this.setState({ buttonDisabled: false });
      }
    }

    this.setState((prevState) => ({
      addCustomerData: {
        ...prevState.addCustomerData,
        [name]: String(value),
      },
    }));
  };

  // add customer input field handler[number format]
  addCustomer_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      addCustomerData: {
        ...prevState.addCustomerData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // add customer add submit handler
  addCustomer_submitHamdler = () => {
    axios
      .post(`/vendor/vendormaster`, {
        entityGst: localStorage.getItem("gst"),
        record: this.state.addCustomerData,
      })
      .then((res) => {
        if (res.data.status === false) {
          let error2 = res.data.message;
          let error = "";
          {
            error2
              ? toast.error(error2, { autoClose: 2000 })
              : Object.keys(res.data.record.details[0].errors_in).map(
                (v, i) => {
                  return (error +=
                    String(v) +
                    " " +
                    res.data.record.details[0].errors_in[v]);
                }
              );
          }
          if (error) {
            toast.error(error, { autoClose: 2000 });
            this.setState({
              add_DrawerOpen: false,
              addCustomerData: {
                erpVendorCode: "",
                address: "",
                contactName: "",
                contactNumber: "",
                vendorEmail: "",
                vendorTan: "",
                purchaseManagerName: "",
                purchaseManagerContactNumber: "",
                purchaseManagerEmail: "",
                gstRegistrationType: "",
                tcsPercentage: null,
                tdsPercentage: null,
                thresholdLimitFlag: "",
                residentFlag: "",
                comments: "",
                vendorGstin: "",
                creditDays: null,
                vendorPan: "",
              },
            });
          }
        } else {
          this.getPurchaseDataApi();
          this.setState({
            add_DrawerOpen: false,
            addCustomerData: {
              erpVendorCode: "",
              address: "",
              contactName: "",
              contactNumber: "",
              vendorEmail: "",
              vendorTan: "",
              purchaseManagerName: "",
              purchaseManagerContactNumber: "",
              purchaseManagerEmail: "",
              gstRegistrationType: "",
              tcsPercentage: null,
              tdsPercentage: null,
              thresholdLimitFlag: "",
              residentFlag: "",
              comments: "",
              vendorGstin: "",
              creditDays: null,
              vendorPan: "",
            },
          });
          toast.success("Vendor added successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // add customer drawer close handler---
  add_DrawerClose = () => {
    this.setState({
      add_DrawerOpen: false,
      addCustomerData: {
        erpVendorCode: "",
        address: "",
        contactName: "",
        contactNumber: "",
        vendorEmail: "",
        vendorTan: "",
        purchaseManagerName: "",
        purchaseManagerContactNumber: "",
        purchaseManagerEmail: "",
        gstRegistrationType: "",
        tcsPercentage: null,
        tdsPercentage: null,
        thresholdLimitFlag: "",
        residentFlag: "",
        comments: "",
        vendorGstin: "",
        creditDays: null,
        vendorPan: "",
      },
    });
  };

  // edit customer[edit button] drawer open handeler---
  editCustomer_drawerOpen = () => {
    this.setState({ edit_DrawerOpen: true });
  };

  // edit customer inputfield handler---
  editCustomer_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "tdsPercentage" || name === "tcsPercentage") {
      if (value > 100)
        if (name === "tdsPercentage") {
          this.setState({ buttonDisabled: true });
        } else {
          this.setState({ buttonDisabled: true });
        }
      else {
        this.setState({ buttonDisabled: false });
      }
    }

    this.setState((prevState) => ({
      editCustomerData: {
        ...prevState.editCustomerData,
        [name]: String(value),
      },
    }));
  };

  editCustomer_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      editCustomerData: {
        ...prevState.editCustomerData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // edit customer edit submit handler
  editCustomer_submitHamdler = () => {
    axios
      .post(`/vendor/vendormaster`, {
        entityGst: localStorage.getItem("gst"),
        record: this.state.editCustomerData,
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = res.data.message;
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.getPurchaseDataApi();
          this.setState({ edit_DrawerOpen: false });
          toast.success("Vendor updated successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        // alert(error);
        this.setState({ edit_DrawerOpen: false });
      });
  };

  // edit customer drawer close handler---
  edit_DrawerClose = () => {
    this.setState({ edit_DrawerOpen: false });
  };
  // ------------------------add customer end-----------------------

  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  export_to_excel = (dataformfun) => {
    // export to excel for both
    let data = dataformfun;
    console.log(data);
    // if (this.state.isEffitrac) {
    //   data = this.state.effitracData;
    // } else {
    //   data = this.state.allArcCustomerDataPurchase;
    // }

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `vendor_management.xlsx`;
    this.setState({ isExporting: true });
    axios
      .post(`/vendor/vendormasterdownload`, {
        data: data,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => {
        if (error.response.data.detail) {
          toast.error(error?.response?.data?.detail, { autoClose: 2000 });
        } else {
          toast.error("Server Error Try After Some Time", { autoClose: 2000 });
        }

        console.log(error);
      }).finally(() => {
        this.setState({ erpDataExportLoading: false, isExporting: false });
      });
  };


  // Export with filters applied: fetch EVERY record matching the applied
  // filters (existing filter api, one page as big as the filtered result) and
  // send exactly those in `data`, the field the existing Export already uses.
  // The extract reads every key below directly, so any key the filter
  // response lacks is filled with an empty value instead of failing.
  VENDOR_EXTRACT_KEYS = [
    "erpVendorCode", "vendorCode", "venodrName", "country", "state", "address",
    "entityGstin", "branchName", "contactName", "contactNumber", "vendorEmail",
    "vendorGstin", "vendorPan", "vendorTan", "purchaseManagerName",
    "purchaseManagerContactNumber", "purchaseManagerEmail", "creditDays",
    "gstRegistrationType", "tcsPercentage", "tdsPercentage", "thresholdLimitFlag",
    "residentFlag", "section206ABFlag", "comments",
  ];

  export_filtered_to_excel = (loadingArg) => {
    // Called from a button click, loadingArg may be the click event; only the
    // Export All / Export Filtered button passes "isExportingAll".
    const loadingKey = loadingArg === "isExportingAll" ? "isExportingAll" : "isExporting";
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    this.setState({ [loadingKey]: true });

    axios
      .post(`/get_vendor_master_detailsFilter`, {
        business_entity_id: localStorage.getItem("business_entity_id"),
        search_text: this.state.searchInput || "",
        filters: this.state.activeFilters,
        number_of_rows_per_page: Math.max(this.state.rowCount || 0, 1),
        page_number: 0,
      })
      .then((res) => {
        const records = (res?.data?.record || []).map((r) => {
          const row = { ...r };
          this.VENDOR_EXTRACT_KEYS.forEach((k) => {
            if (row[k] === undefined || row[k] === null) row[k] = "";
          });
          return row;
        });
        if (records.length === 0) {
          toast.error("No records found for the selected filters", { autoClose: 2000 });
          return;
        }
        return axios
          .post(`/vendor/vendormasterdownload`, {
            data: records,
            business_entity_id: localStorage.getItem("business_entity_id"),
          })
          .then((r) => {
            this.downloadBase64File(contentType, r.data.file, `vendor_management.xlsx`);
          });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to export filtered data", { autoClose: 2000 });
      })
      .finally(() => {
        this.setState({ erpDataExportLoading: false, [loadingKey]: false });
      });
  };

  exportall_to_excel = (dataFromFunction) => {
    // export to excel for both
    let data = dataFromFunction;
    // if (this.state.isEffitrac) {
    //   data = this.state.effitracData;
    // } else {
    //   data = this.state.allArcCustomerData;
    // }

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `vendor_management.xlsx`;
    this.setState({ isExportingAll: true });

    axios
      .post(`/vendor/vendormasterdownload`, {
        // data: data,
        allData: true,
        business_entity_id: localStorage.getItem("business_entity_id")
      })
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        this.setState({ erpDataExportLoading: false, isExportingAll: false }); 
      });
  };


  export_erp_data_to_excel = (apPointName, transId) => {
    this.setState({ erpDataExportLoading: true })
      const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `vendor_management.xlsx`;

  const payLoadData = {
      'business_entity_id': localStorage.getItem('business_entity_id'),
      'record_type': apPointName,
      'record_id': transId
    }
    axios.post('/export_erp_connector_data', payLoadData)
      .then((res) => {
        if (res) {
         this.downloadBase64File(contentType, res.data.data, filename);
        } else {
          toast.error("Data not found. Please try again later.", {
            autoClose: 2000,
          });
           this.setState({ erpDataExportLoading: false });
        }
      })
      .catch((err) => {

      }).finally(() => {
        this.setState({ erpDataExportLoading: false })
      })


  };

  // import effitrac button onclick[from handler]
  import_Effitrac_tally = () => {
    this.setState({ openImportEffitracDrawer: true });
  };

  importEffitracCreatedFromDateChangeHandler = (v) => {
    let dateAndTime = v.toISOString().replace("Z", "");
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        vendor_last_modified_time: dateAndTime,
      },
    }));
  };

  importEffitracCreatedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        vendorBillsToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importEffitracFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        modifiedFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importEffitracModifiedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        modifiedToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  fetchEffitacFormSubmitHandler = () => {
    this.setState({ effitracImportFormloader: true });
    this.setState((prevState) => ({
      importEffitracFetchData: {
        ...prevState.importEffitracFetchData,
        business_entity_id: localStorage.getItem("business_entity_id"),
      },
    }));
    const data = this.state.importEffitracFetchData;
    axios
      .post("/arc/effitrac/customerdataexport", data)
      .then((res) => {
        this.setState({
          isEffitrac: true,
          effitracData: res.data.records.records,
          oldEffitracData: res.data.records.records,
          importEffitracFetchData: {},
          openImportEffitracDrawer: false,
          effitracImportFormloader: false,
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          autoClose: 2000,
        });
        this.setState({ effitracImportFormloader: false });
      });
  };

  closeEffitracDrawer = () => {
    this.setState({
      openImportEffitracDrawer: false,
      importEffitracFetchData: {},
      effitracImportFormloader: false,
    });
  };

  closeEffitracInvShowHandler = () => {
    this.setState({
      effitracInvShow: false,
      targetId: null,
    });
  };

  // import to cws button onclick--
  importToCWS = (data, uploadType = "Zoho", transId) => {
    this.setState({ importToCwsLoading: true })
    let payLoadData = {}
    if (uploadType !== "Zoho") {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: data,
        upload_type: uploadType,
        api_point_name: "vendor",
        is_import: true,
        record_id: transId,
      }
    } else {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: data,
        upload_type: uploadType
      }
    }
    axios
      .post("/arc/effitrac/vendormaster", payLoadData)
      .then((res) => {
        // this.setState({
        //   showUploadHistroyTable: true,
        // });
        this.refreshUploadHistoryTable();
        toast.success("Uploading Files Into Database", {
          autoClose: 5000,
          progress: 0,
        });

        // edited by harsh json formate had been change Status Code: 204 NO CONTENT

        // res.data.record.details.map((row, index) => {
        //   if ("status" in row && row["status"] === "Fail") {
        //     row["record"]["InvoiceNo"] =
        //       "invoiceNo" in row["record"] ? row["record"]["invoiceNo"] : "";
        //     row["record"]["GSTIN"] =
        //       "gstin" in row["record"] ? row["record"]["gstin"] : "";
        //     return row;
        //   }
        //   return false;
        // });
        // var error_records = [];
        // let promises = res.data.record.details.map((v, i) => {
        //   if (v.status == "Fail") {
        //     error_records.push(v);
        //   }
        //   return true;
        // });
        // Promise.all(promises).then(() => {
        //   dis.setState({
        //     total_records: parseInt(res.data.record.summary.total_records),

        //     successful_records: parseInt(res.data.record.summary.valid_records),
        //     error_records: parseInt(res.data.record.summary.invalid_records),
        //     sellerCustomerData: error_records,
        //     error: null,
        //     showUploadData: true,
        //     loading: false,
        //   });
        // });
      })
      .catch((error) => {
        toast.error(error.response.data.messge, {
          autoClose: 5000,
          progress: 0,
        });
      }).finally(() => {
        this.setState({ importToCwsLoading: false })
        this.closeErpDrawer()
      });
  };

  // back button after import effitrac data
  backHandler = () => {
    this.setState({ isEffitrac: false });
  };

  //...............Edited By Harsh Handle Drawer.........
  handleZohoDrawer = () => {
    flagForVendorMang = 1;
    this.setState({ openZohoDrawer: true });
  };

  closeZohoDrawer = () => {
    clearInterval(variableForTimerForZoho);
    this.setState({
      zohoDate: {},
      openZohoDrawer: false,
      effitracImportFormloader: false,
      buttonColor: "red",
      messageForConnection: "Establish Connection",
      grantToken: "",
    });
  };

  closeErpDrawer = () => {
    this.setState({
      erpConnectorModelOpen: false,
    });
  };

  establishConnection = (e) => {
    e.preventDefault();
    window.location.href = `https://accounts.zoho.in/oauth/v2/auth?scope=ZohoBooks.fullaccess.READ&client_id=${localStorage.getItem(
      "Client_ID"
    )}&state=testing&response_type=code&redirect_uri=${this.state.url
      }/zohoTesting&access_type=offline&prompt=Consent`;
  };

zohoDateChangeHandler = (item) => {
  const { name, value } = item;

  var d = new Date(value);
  var newd = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  let dateValue = newd.toISOString().replace("Z", "");

  this.setState((prevState) => ({
    zohoDate: {
      ...prevState.zohoDate,
      [name]: dateValue,
    },
  }));
};

  fetchingdataForZoho = () => {
    clearInterval(variableForTimerForZoho);
    flagForVendorMang += 1;


    this.setState({ effitracImportFormloader: true });
    axios
      .post("/arc/zoho_import", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        code: this.state.grantToken,
        type_of_data: "purchase_vendor",
        redirect_uri: `${this.state.url}/zohoTesting`,
        date: this.state.zohoDate,
        auto_sync: this.state.autoSync,
      })
      .then((res) => {
        if (res.data.status === true) {
          this.setState({
            zohoDate: {},
            effitracImportFormloader: false,
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
            autoSync: false,
          });
        } else {
          this.setState({
            zohoDate: {},
            effitracImportFormloader: false,
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
            autoSync: false,
          });
          toast.error(res.data.message, {
            autoClose: 5000,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        this.setState({
          zohoDate: {},
          effitracImportFormloader: false,
          buttonColor: "red",
          messageForConnection: "Establish Connection",
          grantToken: "",
          autoSync: false,
        });
        toast.error(err?.response?.data?.message, {
          autoClose: 5000,
          progress: 0,
        });
      });

  };

  uploadReport = (id, pageParam = null) => {
    // Get ID from localStorage if not provided
    let currentId = id;
    if (!currentId) {
      currentId = localStorage.getItem('uploadReportId');
    }

    // If still no ID, show error
    if (!currentId) {
      console.error("uploadReport: Invalid ID", currentId);
      this.setState({ error: "Invalid ID", loading: false });
      return;
    }

    // Store ID in localStorage for future use
    localStorage.setItem('uploadReportId', currentId);

    const page = pageParam !== null ? pageParam : this.state.errorPage;
    const perErrorPages = this.state.perErrorPages || 10;

    if (page < 1 || !Number.isInteger(page)) {
      console.error("uploadReport: Invalid page number", page);
      this.setState({ error: "Invalid page number", loading: false });
      return;
    }

    if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
      console.error("uploadReport: Invalid rows per page", perErrorPages);
      this.setState({ error: "Invalid rows per page", loading: false });
      return;
    }

    console.log(`Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`);
    console.log(`API URL: /arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`);

    this.setState({ loading: true, error: null });

    axios
      .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
      .then((response) => {
        console.log("API Response:", JSON.stringify(response.data, null, 2));
        const res = response.data.records;

        if (res.type === "json" && res.records && Array.isArray(res.records.details)) {
          const error_records = res.records.details.filter((v) => v.status === "Fail");
          this.setState({
            showUploadData: true,
            uploadStatusFail: res.records,
            total_records: parseInt(res.records.summary?.total_records) || 0,
            successful_records: parseInt(res.records.summary?.valid_records) || 0,
            error_records: parseInt(res.records.summary?.invalid_records) || 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: error_records,
            error: null,
            loading: false,
          });
        } else if (res.type === "message") {
          this.setState({
            showUploadData: true,
            uploadStatusFail: res,
            total_records: 0,
            successful_records: 0,
            error_records: 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: [],
            error: res.message,
            loading: false,
          });
        } else {
          console.warn("Invalid response format:", res);
          this.setState({
            error: "Invalid response format",
            total_records: 0,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        this.setState({
          loading: false,
          error: `Failed to fetch data: ${error.message}`,
        });
      });
  };

  // uploadReport = (id) => {
  //   axios
  //     .get(`/arc/get_data_upload_json/${id}`)
  //     .then((response) => {
  //       this.setState({
  //         showUploadData: true,
  //         uploadStatusFail: response.data.records,
  //       });
  //       let res = response.data.records.records;

  //       if (response.data.records.type === "json") {
  //         var error_records = [];
  //         let promises = res.details.map((v, i) => {
  //           if (v.status === "Fail") {
  //             error_records.push(v);
  //           }
  //           return true;
  //         });

  //         Promise.all(promises).then(() => {
  //           this.setState({
  //             total_records: parseInt(res.summary.total_records),
  //             successful_records: parseInt(res.summary.valid_records),
  //             error_records: parseInt(res.summary.invalid_records),
  //             sellerCustomerData: error_records,
  //             error: null,
  //             loading: false,
  //           });
  //           return true;
  //         });
  //       } else {
  //         this.setState({
  //           error: response.data.records.message,
  //           total_records: 0,
  //           loading: false,
  //         });
  //       }
  //     })
  //     .catch((error) => { });
  // };

  errorLogExportHandlerForUpload = () => {
    // Get the currentId from localStorage
    this.setState({ loadingExport: true });

    let uploadId = localStorage.getItem('uploadReportId');

    let data = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      upload_id: uploadId,
    };

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `vendorManagementUploadErrorLog.xlsx`;

    axios
      .post(`/uploads_errors_extract/download`, data)
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
        this.setState({ loadingExport: false });
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
        this.setState({ loadingExport: false });
      });

  };

  uploadTanCancelHandler = () => {
    this.setState({ isOpenUpdateTanModal: false });
  };
  // upload TAN
  uploadTanGetApiHandler = () => {
    console.log("\nINSIDE uploadTanGetApiHandler. Calling API to get previous log and count of TANs...");
    this.setState({ isLoaderforupdateTanButton: true });
    axios
      .get(`/karza_vendor_log/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        console.log("handling response of karza_log")
        // console.log(res.data)
        if (res.data) {
          this.setState({
            updateTanGetApiData: res.data,
            isLoaderforupdateTanButton: false,
          });

          this.setState({ isOpenUpdateTanModal: true });
        }
      });
  };

  uploadTanPostApiHandler = () => {
    console.log("\nINSIDE uploadTanPostApiHandler. Calling API to get Karza TANs...")
    axios
      .get(`/karza_vendor_tan/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data && res.data.status === true) {
          toast.success(res.data.Message, {
            autoClose: 3000,
          });
          this.setState({ isOpenUpdateTanModal: false });
        } else {
          toast.error(res.data.Message, {
            autoClose: 3000,
          });
        }
      });
  };

  handleErpConnectorButton = () => {
    this.setState({ erpConnectorModelOpen: true })
  }

  render() {
    // const { push, ...props } = this.props;
    return (
      <React.Fragment>
        <ZohoModel
          openZohoDrawer={this.state.openZohoDrawer}
          buttonColor={this.state.buttonColor}
          establishConnection={this.establishConnection}
          messageForConnection={this.state.messageForConnection}
          timerForZohoInSalesCustomer={this.state.timerForZoho}
          closeZohoDrawer={this.closeZohoDrawer}
          zohoDateChangeHandler={this.zohoDateChangeHandler}
          effitracImportFormloader={this.state.effitracImportFormloader}
          fetchingdataForZoho={this.fetchingdataForZoho}
          zohoDate={this.state.zohoDate}
          logApitName="purchase_vendor"
          nameOfTheModel="Vendor Management"
          importToCWS={this.importToCWS}
          exportToExcel={this.export_to_excel}
          zohoTableHeader={this.state.effitracHeader}
          zohoTableColumn={this.state.effitracCol}
          drawerKeys={this.state.actionHeaderForZoho}
          autoSync={this.state.autoSync} // Added autoSync prop
          setAutoSync={this.handleAutoSyncChange} // Added setAutoSync prop
        />

        <ErpConnectorModel
          opeErpConnector={this.state.erpConnectorModelOpen}
          closeErpConnector={this.closeErpDrawer}
          logApitName="vendor"
          nameOfTheModel="Vendor Management"
          importToCWS={this.importToCWS}
          exportToExcel={this.export_erp_data_to_excel}
          ErpTableHeader={this.state.effitracHeader}
          ErpTableColumn={this.state.effitracCol}
          connecotrName={this.state.erpConnectorName}
          erpDataExportLoading={this.state.erpDataExportLoading}
          importToCwsLoading={this.state.importToCwsLoading}
        />


        <BasicModal
          title={"Update Tan"}
          enableFooter={true}
          open={this.state.isOpenUpdateTanModal}
          modalBody={
            this.state.updateTanGetApiData.status === false ? (
              <p style={{ color: "red" }}>
                {this.state.updateTanGetApiData.message}
              </p>
            ) : (
              <p>{this.state.updateTanGetApiData.message}</p>
            )
          }
          modalSize={"md"}
          onClose={this.uploadTanCancelHandler}
          modalFooter={
            <>
              {
                this.state.updateTanGetApiData.status &&
                <button
                  className="button-primary"
                  type="button"
                  style={{ marginRight: "10px" }}
                  onClick={this.uploadTanPostApiHandler}
                  disabled={
                    this.state.updateTanGetApiData.status === false ? true : false
                  }
                >
                  ok
                </button>
              }
              <button
                className="button-outlined-secondary"
                type="button"
                onClick={this.uploadTanCancelHandler}
              >
                Close
              </button>
            </>
          }
        />
        {(localStorage.getItem('is_uploads') !== "N") && <>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
    <Tooltip title="Back" arrow>
      <IconButton
        onClick={() => this.props.history.push('/Data-Upload')}
        sx={{
          borderRadius: '50%',
          padding: '6px',
          color: '#263238',
          backgroundColor: '#ffffff',
          height: '36px',
          width: '36px',
          '&:hover': {
            backgroundColor: '#455a64',
            color: '#ffffff',
          },
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
          transition: 'background-color 0.3s ease',
        }}
      >
        <ArrowBackIcon sx={{ fontSize: '20px' }} />
      </IconButton>
    </Tooltip>
    {canWrite("UPLOADING PURCHASE") && (

            <button
              type="button"
              onClick={this.uploadTanGetApiHandler}
              className="button-primary"
              disabled={this.state.isLoaderforupdateTanButton ? true : false}
            >
              {this.state.isLoaderforupdateTanButton ? "Updating..." : "Update TAN"}
            </button>
            )}
          </div>


          {(localStorage.getItem('is_uploads') !== "N") && (
            <div>
              <BoxWrapper
                boxTitle="Upload Vendor History"
                zohoEffitracEnable={
                  localStorage.getItem("Client_ID") &&
                  !this.state.isEffitrac &&
                canWrite("UPLOADING PURCHASE") &&
                  true
                }
                zohoEffitracFn={this.handleZohoDrawer}
              enableAddButton={this.state.erpConnectorName && canWrite("UPLOADING PURCHASE") ? true : false}
                addButtonLabel={this.state.erpConnectorName}
                addButtonHandlerFn={this.handleErpConnectorButton}
              // enableImportToEffTallybutton={localStorage.getItem("Trigger_Effitrac/Tally_Button") && localStorage.getItem("Trigger_Effitrac/Tally_Button") === "true" && !this.state.isEffitrac}
              // importToEffiTallyFn={this.import_Effitrac_tally}
              >
                <this.CollectionListActions />
                <div className="responsive-table">
                  <table className="custome-table">
                    <thead>
                      <tr>
                        <th>Last Upload Date & Time</th>
                        <th>Status</th>
                        <th>Upload Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.uploadHistoryTableData.map((item, i) => {
                        return (
                          <tr>
                            <td>{item.upload_date}</td>
                            <td>{item.status}</td>
                            <td>{item.upload_type}</td>
                            <td>
                              {item.status === "In Progress" ? (
                                <VisibilityIcon color="disabled" />
                              ) : item.status === "Uploaded" ? (
                                <VisibilityIcon color="disabled" />
                              ) : (
                                <RemoveRedEyeOutlinedIcon
                                  className="action-icon-button showIcon"
                                  onClick={() => this.uploadReport(item.id)}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      {this.state.uploadHistoryTableData.length === 0 && (
                        <tr>
                          <td
                            colspan={4}
                            style={{ color: "red", textAlign: "center" }}
                          >
                            No Data Found!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </BoxWrapper>
            </div>
          )}

        </>}

        {this.state.showUploadData ? (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className={classes.Main_frame}>
                  <div className={classes.form_title_bar}>
                    <div class="form_title_name">
                      <ul
                        style={{
                          listStyle: "none",
                          marginBottom: "0px",
                          padding: "0px",
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <li style={{ fontWeight: "700" }}>Upload Details</li>
                        <li>
                          {this.state.error_records > 0 && (
                            // <button
                            //   className="button-outlined-primary"
                            //   onClick={this.errorLogExportHandlerForUpload}
                            // >
                            //   Export
                            // </button>
                            <button
                              className="button-outlined-primary"
                              onClick={this.errorLogExportHandlerForUpload}
                              disabled={this.state.loadingExport} // Disable button during loading
                            >
                              {this.state.loadingExport ? (
                                <span>Loading...</span> // Simple text loader
                              ) : (
                                <span>Export</span>
                              )}
                            </button>
                          )}

                          <button
                            className="close-icon-button"
                            onClick={this.closeUploadData}
                          >
                            <ClearIcon style={{ color: "var(--app-bar-bg)" }} />
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className={classes.form_body_part}>
                    {this.state.total_records > 0 && (
                      <div>
                        {/* card component */}
                        <div
                          style={{ marginLeft: "30px", marginRight: "30px" }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#6f9eaf"
                                cardTitle="Total Records"
                                cardBody={this.state.total_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#007965"
                                cardTitle="Successful Records"
                                cardBody={this.state.successful_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#eb596e"
                                cardTitle="Error Records"
                                cardBody={this.state.error_records}
                              />
                            </Grid>
                          </Grid>
                        </div>

                        {/* datatable component */}
                        <div
                          style={{
                            height: "300",
                            margin: "20px 30px 0px 30px",
                          }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <div>
                                <MuiThemeProvider>
                                  {/* <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    showRowHover={true}
                                    page={1}
                                    count={this.state.total_records}
                                  // showCheckboxes={true}
                                  /> */}
                                  <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    page={this.state.errorPage}
                                    count={this.state.errortotal}
                                    rowSize={this.state.perErrorPages}
                                    showRowSizeControls={true}
                                    showFooterToolbar={true}
                                    onNextPageClick={this.handleNextPage}
                                    onPreviousPageClick={this.handlePreviousPage}
                                    onRowSizeChange={this.handleRowsPerPageChange}
                                  />
                                </MuiThemeProvider>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    )}
                    {this.state.error && (
                      <div style={{ color: "red" }}>
                        <ErrorIcon />
                        {this.state.error}
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        ) : (
          ""
        )}

        {/* arc customer table */}
        <BoxWrapper
          boxTitle="Vendor Details"
          // export to excel
          exportToExcelEnable={true}
          exportToExcelFn={() =>
            this.state.appliedFilters.length > 0 && this.state.activeFilters
              ? this.export_filtered_to_excel()
              : this.export_to_excel(this.state.allArcCustomerDataPurchase)
          }
          loadingexcel={this.state.isExporting}
          exportToExcelEnable1={true}
          exportButtonLabel1={this.state.appliedFilters.length > 0 && this.state.activeFilters ? "Export Filtered" : "Export All"}
          exportToExcelFn1={() => {
            if (this.state.appliedFilters.length > 0 && this.state.activeFilters) {
              this.export_filtered_to_excel("isExportingAll");
            } else {
              this.exportall_to_excel(this.state.allArcCustomerDataPurchase);
            }
          }}
          loadingexcel1={this.state.isExportingAll}
          // search input
          // enableSearchInput={true}
          // searchInputPlaceholder="Search..."
          // searchInputOnchange={
          //   this.state.isEffitrac
          //     ? this.handleSearchInputChangeFroEffitrackAndZoho
          //     : this.handleSearchInputChange
          // }
          // back button
          backButtonForZohoEnable={this.state.isEffitrac}
          backButton={this.backHandler}
          // import to cws button
          importToCwsEnableForZoho={this.state.isEffitrac}
          importToCwsForZoho={this.importToCWS}
          // Filter button inside the BoxWrapper header (see
          // FILTER_BUTTON_IN_BOXWRAPPER at the top of this file)
          headerExtra={
            FILTER_BUTTON_IN_BOXWRAPPER && !this.state.isEffitrac
              ? this.renderFilterButton()
              : null
          }
        >
          {this.state.isEffitrac ? (
            <CustomTable
              headers={this.state.effitracHeader}
              columns={this.state.effitracCol}
              data={this.state.effitracData}
              actions={this.state.actions}
            />
          ) : (
            <>
              {/* Filter button here only until it is moved into BoxWrapper */}
              {!FILTER_BUTTON_IN_BOXWRAPPER && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "8px",
                  }}
                >
                  {this.renderFilterButton()}
                </div>
              )}

              {this.renderAppliedFilterChips()}

              {/* Table on the left, filter panel (when open) on the right —
                  the panel stretches to the table's height. */}
              <div style={{ display: "flex", alignItems: "stretch", gap: "12px" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {/*
                    overflowX: "auto" turns the wide, fixed-width grouped table
                    below into a horizontally-scrolling region instead of
                    letting the browser squeeze the columns to fit. The table's
                    own minWidth is the sum of every column's fixed width plus
                    the sticky SHOW column.
                  */}
                  <div
                    className="responsive-table"
                    style={{ overflowX: "auto", overflowY: "visible", maxWidth: "100%" }}
                  >
                    <table
                      className="custome-table"
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        minWidth: this.getTableMinWidth(),
                        tableLayout: "fixed",
                        width: "100%",
                      }}
                    >
                      {/*
                        colgroup pins every column to its real width. Without it,
                        table-layout:fixed reads widths from the FIRST row (the
                        group-band row, whose cells use colSpan), which splits a
                        band's width evenly across its columns and pushes the
                        labels and data out of line.
                      */}
                      <colgroup>
                        {this.allColumns().map((col) => (
                          <col key={col.key} style={{ width: col.width, minWidth: col.width }} />
                        ))}
                        <col style={{ width: this.SHOW_COL_WIDTH, minWidth: this.SHOW_COL_WIDTH }} />
                      </colgroup>
                      <tbody>
                        {/* Grouped header: returns [groupRow, labelRow] — each
                            is already a <tr>, so no extra <tr> wrapper here. */}
                        {this.arc_Customer_TableHeader()}
                        {this.arc_Customer__data()}
                      </tbody>
                    </table>
                  </div>
                  <TablePagination
                    rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                    component="div"
                    count={this.state.rowCount} //total row count
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </div>

                {this.renderFilterPanel()}
              </div>
            </>
          )}
        </BoxWrapper>

        {/*.......,.Edited by Harsh..............*/}
        {/* <Drawer
          anchor="right"
          open={this.state.openZohoDrawer}
          onClose={this.closeZohoDrawer}
        >
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <button
              className="button-outlined-primary"
              disabled={this.state.buttonColor === "green" ? true : false}
              onClick={this.establishConnection}
            >
              {this.state.messageForConnection}
            </button>
          </div>

          {this.state.buttonColor === "green" && (
            <div
              style={{
                textAlign: "center",
                fontSize: "14px",
                marginTop: "10px",
              }}
            >
              <span
                style={{
                  color: this.state.timerForZoho < 30 ? "red" : "green",
                }}
              >
                Connection will be lost In{"  "}
                {this.state.timerForZoho} Seconds
              </span>
            </div>
          )}

          <ValidatorForm
            ref="form"
            onSubmit={this.fetchingdataForZoho}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ marginTop: "20px" }}>
              <label>
                Created From Date<span style={{ color: "red" }}>*</span>:
              </label>
              <ValidatedDatePicker
                fullWidth
                name="created_from_date"
                value={this.state.zohoDate.created_from_date ?? ""}
                onChange={(v) =>
                  this.zohoDateChangeHandler({
                    name: "created_from_date",
                    value: v,
                  })
                }
                requiredField="*"
                validators={["required"]}
                errorMessages={["This field is required"]}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>
                Modified From Date<span style={{ color: "red" }}>*</span>:
              </label>
              <ValidatedDatePicker
                name="modified_from_date"
                value={this.state.zohoDate.modified_from_date ?? ""}
                onChange={(v) =>
                  this.zohoDateChangeHandler({
                    name: "modified_from_date",
                    value: v,
                  })
                }
                requiredField="*"
                validators={["required"]}
                errorMessages={["This field is required"]}
              />
            </div>

              {this.state.effitracImportFormloader ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}

              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeZohoDrawer}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer> */}

        {/* import tally/Effitrac drawer */}
        <RightDrawer
          drawerName="Import Tally/Effitrac"
          open={this.state.openImportEffitracDrawer}
          onClose={this.closeEffitracDrawer}
        >
          <div style={{ textAlign: "center" }}>
            Last Upload Date<br></br>
            {this.state.lastUploadDate} {this.state.lastUploadTime}
          </div>

          <ValidatorForm
            ref="form"
            onSubmit={this.fetchEffitacFormSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ marginTop: "20px" }}>
              <label>
                Created From Date<span style={{ color: "red" }}></span>:
              </label>
              <ValidatedDatePicker
                fullWidth
                name="createdFromDate"
                value={
                  this.state.importEffitracFetchData.vendorBillsFromDate ?? ""
                }
                onChange={(v) =>
                  this.importEffitracCreatedFromDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>
                Created To Date<span style={{ color: "red" }}></span>:
              </label>
              <ValidatedDatePicker
                name="createdToDate"
                value={
                  this.state.importEffitracFetchData.vendorBillsToDate ?? ""
                }
                onChange={(v) =>
                  this.importEffitracCreatedToDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>
                Modified From Date<span style={{ color: "red" }}></span>:
              </label>
              <ValidatedDatePicker
                name="modifiedFromDate"
                value={
                  this.state.importEffitracFetchData.modifiedFromDate ?? ""
                }
                onChange={(v) => this.importEffitracFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>
                Modified To Date<span style={{ color: "red" }}></span>:
              </label>
              <ValidatedDatePicker
                name="modifiedToDate"
                value={this.state.importEffitracFetchData.modifiedToDate ?? ""}
                onChange={(v) =>
                  this.importEffitracModifiedToDateChangeHandler(v)
                }
              />
            </div>
            {/* submit and back button */}
            <div className="mt-20">
              {this.state.effitracImportFormloader ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}

              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeEffitracDrawer}
              >
                cancel
              </button>
            </div>
          </ValidatorForm>
        </RightDrawer>
        {/* import tally/effitrac end */}

        {/*arc show  drawer */}
        <RightDrawer
          drawerName="Vendor Details"
          open={this.state.showDrawer}
          onClose={this.showToggleDrawerClose}
          style={{ width: 500 }}
        >
          {Object.keys(this.state.showData).length && (
            <>
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Country"
                value={this.state.showData.country ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="State"
                value={this.state.showData.state ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Contact Name"
                value={this.state.showData.contactName ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Contact Number"
                value={this.state.showData.contactNumber ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Email"
                value={this.state.showData.vendorEmail ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Address"
                value={this.state.showData.address ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="PAN"
                value={this.state.showData.vendorPan ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="TAN"
                value={this.state.showData.vendorTan ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="TCS %"
                value={this.state.showData.tcsPercentage ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="GST Registration Type"
                value={this.state.showData.gstRegistrationType ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Purchase Manager Name"
                value={this.state.showData.purchaseManagerName ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Purchase Manager  Number"
                value={this.state.showData.purchaseManagerContactNumber ?? ""}

              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Purchase Manager Email"
                value={this.state.showData.purchaseManagerEmail ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Credit Days"
                value={this.state.showData.creditDays ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Create Date"
                value={this.state.showData.create_date ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Modify Date"
                value={this.state.showData.modify_date ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="TDS Threshold Applicability"
                value={this.state.showData.thresholdLimitFlag}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Resident"
                value={this.state.showData.residentFlag}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Section 206AB"
                value={this.state.showData.section206ABFlag}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Comments"
                value={this.state.showData.comments}
              />
            </>
          )}
          <button
            type="button"
            className="button-outlined-secondary mt-20"
            onClick={this.showToggleDrawerClose}
          >
            close
          </button>
        </RightDrawer>

        {/* arc add drawer  */}
        <Drawer
          anchor="right"
          open={this.state.add_DrawerOpen}
          onClose={this.add_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.addCustomer_submitHamdler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="Vendor Name"
                name="venodrName"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCustomerData.venodrName ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Vendor Code+"
                name="erpVendorCode"
                value={this.state.addCustomerData.erpVendorCode ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Country"
                name="country"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCustomerData.country ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="State"
                name="state"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCustomerData.state ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Address"
                name="address"
                value={this.state.addCustomerData.address ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Contact Name"
                name="contactName"
                value={this.state.addCustomerData.contactName ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Contact Number"
                name="contactNumber"
                requiredField=""
                validator={["matchRegexp:^[0-9]{10}$"]}
                errorMsg={["Invalid contact number"]}
                value={this.state.addCustomerData.contactNumber ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Email"
                name="vendorEmail"
                validator={["isEmail"]}
                errorMsg={["Email is not valid"]}
                value={this.state.addCustomerData.vendorEmail ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="GSTIN"
                validator={[
                  "matchRegexp:^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$",
                ]}
                errorMsg={["Invalid GSTIN Number"]}
                name="vendorGstin"
                value={this.state.addCustomerData.vendorGstin ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="PAN"
                name="vendorPan"
                validator={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? ["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$"]
                    : ["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$"]
                }
                errorMsg={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? ["Invalid PAN Number"]
                    : ["Invalid PAN Number"]
                }
                value={this.state.addCustomerData.vendorPan ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="TAN"
                name="vendorTan"
                validator={["matchRegexp:[A-Z]{4}[0-9]{5}[A-Z]{1}$"]}
                errorMsg={["Invalid TAN Number"]}
                value={this.state.addCustomerData.vendorTan ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Purchase Manager Name"
                name="purchaseManagerName"
                value={this.state.addCustomerData.purchaseManagerName ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Purchase Manager Contact Number"
                name="purchaseManagerContactNumber"
                requiredField=""
                validator={["matchRegexp:^[0-9]{10}$"]}
                errorMsg={["Invalid contact number"]}
                value={
                  this.state.addCustomerData.purchaseManagerContactNumber ?? ""
                }
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Purchase Manager Email"
                name="purchaseManagerEmail"
                validator={["isEmail"]}
                errorMsg={["Email is not valid"]}
                value={this.state.addCustomerData.purchaseManagerEmail ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Credit Days"
                name="creditDays"
                // requiredField="*"
                validator={["matchRegexp:[0-9]"]}
                errorMsg={["Must be number"]}
                value={this.state.addCustomerData.creditDays ?? ""}
                textOnchangeFunction={this.addCustomer_inputNumberHandler}
              />

              <SelectField
                SelectLabel="GST Registration Type"
                choice_id="id"
                choice_name="GSTRegistrationType"
                name="gstRegistrationType"
                value={this.state.addCustomerData.gstRegistrationType ?? ""}
                choices={[
                  { id: "Regular", GSTRegistrationType: "Regular" },
                  { id: "Unregistered", GSTRegistrationType: "Unregistered" },
                  { id: "Consumer", GSTRegistrationType: "Consumer" },
                  { id: "Composition", GSTRegistrationType: "Composition" },
                  { id: "Unknown", GSTRegistrationType: "Unknown" },
                ]}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="TDS %"
                name="tdsPercentage"
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.addCustomerData.tdsPercentage ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="TCS %"
                name="tcsPercentage"
                // step=".01"
                // requiredField=""

                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.addCustomerData.tcsPercentage ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />
              <SelectField
                SelectLabel="TDS Threshold Limit Applicability"
                choice_id="id"
                choice_name="ThresholdLimitFlag"
                name="thresholdLimitFlag"
                value={this.state.addCustomerData.thresholdLimitFlag ?? ""}
                choices={[
                  { id: "Applicable", ThresholdLimitFlag: "Applicable" },
                  {
                    id: "Not applicable",
                    ThresholdLimitFlag: "Not applicable",
                  },
                ]}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />
              <SelectField
                SelectLabel="Resident"
                choice_id="id"
                choice_name="ResidentFlag"
                name="residentFlag"
                value={this.state.addCustomerData.residentFlag ?? ""}
                choices={[
                  { id: "Resident", ResidentFlag: "Resident" },
                  { id: "Non Resident", ResidentFlag: "Non Resident" },
                ]}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />
              <SelectField
                SelectLabel="Section 206AB"
                choice_id="id"
                choice_name="Section206ABFlag"
                name="section206ABFlag"
                value={this.state.addCustomerData.section206ABFlag ?? ""}
                choices={[
                  { id: "Yes", Section206ABFlag: "Yes" },
                  { id: "No", Section206ABFlag: "No" },
                ]}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Comments"
                name="comments"
                value={this.state.addCustomerData.comments ?? ""}
                textOnchangeFunction={this.addCustomer_inputHandler}
              />

              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
                disabled={this.state.buttonDisabled}
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="contained"
                size="small"
                onClick={this.add_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
            {/* Drawer body end */}
          </div>
        </Drawer>
        {/* arc add drawer end */}

        {/* arc edit drawer  */}
        <Drawer
          anchor="right"
          open={this.state.edit_DrawerOpen}
          onClose={this.edit_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.editCustomer_submitHamdler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="Vendor Name"
                name="venodrName"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editCustomerData.venodrName ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Vendor Code+"
                name="erpVendorCode"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editCustomerData.erpVendorCode ?? ""}
              />

              <InputField
                inputType="text"
                textLabel="Country"
                name="country"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCustomerData.country ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="State"
                name="state"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCustomerData.state ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Address"
                name="address"
                value={this.state.editCustomerData.address ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Contact Name"
                name="contactName"
                value={this.state.editCustomerData.contactName ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Contact Number"
                name="contactNumber"
                requiredField=""
                validator={["matchRegexp:^[0-9]{10}$"]}
                errorMsg={["Invalid contact number"]}
                value={this.state.editCustomerData.contactNumber ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Email"
                name="vendorEmail"
                validator={["isEmail"]}
                errorMsg={["Email is not valid"]}
                value={this.state.editCustomerData.vendorEmail ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="vendorGstin"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editCustomerData.vendorGstin ?? ""}
              // textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="PAN"
                name="vendorPan"
                requiredField={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? "*"
                    : ""
                }
                validator={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? [
                      "required",
                      "matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$",
                    ]
                    : ["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$"]
                }
                errorMsg={
                  (this.state.addCustomerData.country || "").toLowerCase() ===
                    "india"
                    ? ["This field is required", "Invalid PAN Number"]
                    : ["Invalid PAN Number"]
                }
                value={this.state.editCustomerData.vendorPan ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="TAN"
                name="vendorTan"
                validator={["matchRegexp:[A-Z]{4}[0-9]{5}[A-Z]{1}$"]}
                errorMsg={["Invalid TAN Number"]}
                value={this.state.editCustomerData.vendorTan ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="purchase Manager Name"
                name="purchaseManagerName"
                value={this.state.editCustomerData.purchaseManagerName ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Purchase Manager Contact Number"
                name="purchaseManagerContactNumber"
                validator={["matchRegexp:^[0-9]{10}$"]}
                errorMsg={["Invalid contact number"]}
                value={
                  this.state.editCustomerData.purchaseManagerContactNumber ?? ""
                }
                textOnchangeFunction={this.editCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Purchase Manager Email"
                name="purchaseManagerEmail"
                validator={["isEmail"]}
                errorMsg={["Email is not valid"]}
                value={this.state.editCustomerData.purchaseManagerEmail ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Credit Days"
                name="creditDays"
                validator={["matchRegexp:[0-9]"]}
                errorMsg={["Must be number"]}
                value={this.state.editCustomerData.creditDays ?? ""}
                textOnchangeFunction={this.editCustomer_inputNumberHandler}
              />

              <SelectField
                SelectLabel="GST Registration Type"
                choice_id="id"
                choice_name="GSTRegistrationType"
                name="gstRegistrationType"
                value={this.state.editCustomerData.gstRegistrationType ?? ""}
                choices={[
                  { id: "Regular", GSTRegistrationType: "Regular" },
                  { id: "Unregistered", GSTRegistrationType: "Unregistered" },
                  { id: "Consumer", GSTRegistrationType: "Consumer" },
                  { id: "Composition", GSTRegistrationType: "Composition" },
                  { id: "Unknown", GSTRegistrationType: "Unknown" },
                ]}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="TDS %"
                name="tdsPercentage"
                requiredField=""
                // validator={["matchRegexp:^([1-9][0-9]?|100)$|^[0-9]{0,2}\.[0-9]{1,2}$|[0]$"]}
                // errorMsg={["invalid percentage."]}
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.editCustomerData.tdsPercentage ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="TCS %"
                name="tcsPercentage"
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.editCustomerData.tcsPercentage ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />
              <SelectField
                SelectLabel="TDS Threshold Limit Applicability"
                choice_id="id"
                choice_name="thresholdLimit"
                name="thresholdLimitFlag"
                value={this.state.editCustomerData.thresholdLimitFlag ?? ""}
                choices={[
                  { id: "Applicable", thresholdLimit: "Applicable " },
                  { id: "Not applicable", thresholdLimit: "Not applicable" },
                ]}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />
              <SelectField
                SelectLabel="Resident"
                choice_id="id"
                choice_name="residentflag"
                name="residentFlag"
                value={this.state.editCustomerData.residentFlag ?? ""}
                choices={[
                  { id: "Resident", residentflag: "Resident" },
                  { id: "Non Resident", residentflag: "Non Resident" },
                ]}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />
              <SelectField
                SelectLabel="section 206AB"
                choice_id="id"
                choice_name="section206ABFlag"
                name="section206ABFlag"
                value={this.state.editCustomerData.section206ABFlag ?? ""}
                choices={[
                  { id: "Yes", section206ABFlag: "Yes" },
                  { id: "No", section206ABFlag: "No" },
                ]}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Comment"
                name="comments"
                value={this.state.editCustomerData.comments ?? ""}
                textOnchangeFunction={this.editCustomer_inputHandler}
              />

              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
                disabled={this.state.buttonDisabled}
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="contained"
                size="small"
                onClick={this.edit_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
            {/* Drawer body end */}
          </div>
        </Drawer>
        {/* arc edit drawer end */}

        {/* effitrac/tally show drawer */}
        <Drawer
          anchor="right"
          open={this.state.effitracInvShow}
          onClose={this.closeEffitracInvShowHandler}
        >
          <div className={classes.showDetails}>
            <>
              <div className={classes.showDetailsBody}>
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Country"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].country
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="State"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].state
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Contact Name"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].contactName
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Contact Number"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].contactNumber
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Email"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].vendorEmail
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Address"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].address
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="PAN"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].vendorPan
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="TAN"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].vendorTan
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="TCS %"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].tcsPercentage
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="GST Registration Type"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId]
                      .gstRegistrationType
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Purchase Manager Name"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId]
                      .purchaseManagerName
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Purchase Manager Contact Number"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId]
                      .purchaseManagerContactNumber
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Purchase Manager Email"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId]
                      .purchaseManagerEmail
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Credit Days"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].creditDays
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="TDS Threshold Limit Applicability"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId]
                      .thresholdLimitFlag
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Resident"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].residentFlag
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Section 206AB"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId]
                      .section206ABFlag
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Comments"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.effitracData[this.state.targetId].comments
                  }
                />
              </div>
            </>
            <Button
              style={{
                marginTop: "25px",
                marginBottom: "30px",
                marginLeft: "10px",
              }}
              variant="contained"
              size="small"
              onClick={this.closeEffitracInvShowHandler}
            >
              Back
            </Button>
          </div>
        </Drawer>
        {/* effitrac/tally show drawer end*/}
      </React.Fragment>
    );
  }
}

export default withRouter(VendorManagement);